(function () {
  var root = document.querySelector("[data-planner2]");
  if (!root) return;

  var scenes = parseJson(root.querySelector("script[data-p2-scenes]")) || [];
  var catalogue = parseJson(root.querySelector("script[data-p2-catalogue]")) || [];
  var seed = parseJson(root.querySelector("script[data-p2-seed]")) || [];
  var stage = root.querySelector("[data-p2-stage]");
  var sceneImg = root.querySelector("[data-p2-scene]");
  var hang = root.querySelector("[data-p2-hang]");
  if (!scenes.length || !stage || !sceneImg || !hang) return;

  var products = {};
  catalogue.forEach(function (product) { products[product.handle] = product; });

  var GAP_CM = 5;
  var SIZE_CHOICES = [
    { tier: "medium", label: "Medium" },
    { tier: "large", label: "Large" },
    { tier: "small", label: "Small" },
    { tier: "xlarge", label: "X-Large" }
  ];
  // Fixed face and mount tables from the shop's framing spec. Not read off
  // the variant. Sheet centimetres are read from the matched variant label.
  var FRAME_FACE_CM = { classic: 2, "deep classic": 2, swoop: 3.5, venice: 3 };
  var MOUNT_CM = { small: 4.5, medium: 5.5, large: 7, xlarge: 8, extralarge: 8 };
  var STYLE_COLOURS = {
    classic: ["Oak", "Black", "White", "Gold", "Silver", "Bronze", "Natural", "Antique Gold", "Antique Silver"],
    "deep classic": ["Oak", "Black", "White", "Gold", "Silver", "Bronze", "Natural", "Antique Gold", "Antique Silver"],
    swoop: ["White", "Black", "Gold", "Silver"],
    venice: ["Silver", "Black and Pewter", "Terracotta and Silver", "White and Silver"]
  };
  var STYLE_DEFAULT = { classic: "Oak", "deep classic": "Oak", swoop: "Black", venice: "Silver" };
  var MOUNT_COLOURS = {
    "White": "#FFFFFF",
    "Snow White": "#EDF0F0",
    "Fresh Linen": "#EEE9E3",
    "Warm Sand": "#E8DABF",
    "French Grey": "#C3BCA8",
    "Olive": "#7E7661",
    "Black": "#2D2824"
  };
  var FINISH = {
    oak: { out: "#cda86f", mid: "#9b7a4d", inn: "#bb976a", hi: "#e6cd9d", grain: "rgba(70,44,16,.13)" },
    black: { out: "#33302d", mid: "#121110", inn: "#262321", hi: "#4d4945", grain: "rgba(255,255,255,.05)" },
    white: { out: "#f3efe9", mid: "#dad4ca", inn: "#eae5dd", hi: "#ffffff", grain: "rgba(0,0,0,.035)" },
    gold: { out: "#d9b978", mid: "#b8934e", inn: "#c9a45c", hi: "#e8d09a", grain: "rgba(90,60,10,.10)" },
    silver: { out: "#d8dbde", mid: "#aeb4b9", inn: "#c4c8cc", hi: "#eceef0", grain: "rgba(0,0,0,.04)" },
    bronze: { out: "#b08d5b", mid: "#7c5c34", inn: "#997745", hi: "#caa870", grain: "rgba(60,30,8,.12)" },
    natural: { out: "#e6d6bc", mid: "#cbb68e", inn: "#d9c7a5", hi: "#f2eadb", grain: "rgba(70,44,16,.10)" },
    "antique-gold": { out: "#c7a867", mid: "#93753f", inn: "#b0924e", hi: "#d9c080", grain: "rgba(80,50,10,.10)" },
    "antique-silver": { out: "#c4c3bc", mid: "#98968c", inn: "#b0aea6", hi: "#d6d5d0", grain: "rgba(0,0,0,.05)" },
    "black-pewter": { out: "#3a3a3e", mid: "#1a1a1c", inn: "#2a2a2e", hi: "#9a9ea1", grain: "rgba(255,255,255,.05)" },
    "terracotta-silver": { out: "#c47852", mid: "#b5673f", inn: "#a05535", hi: "#c9ccce", grain: "rgba(80,40,10,.10)" },
    "white-silver": { out: "#f0ede7", mid: "#e0dbd2", inn: "#ece8e0", hi: "#cfd2d5", grain: "rgba(0,0,0,.04)" }
  };

  var STORAGE = "planner2.selection";
  var HOLD_KEY = "planner2.hold";
  var HINT_KEY = "planner2.hint";
  var loginHold = null;
  var state = loadState();
  if (loginHold) {
    persist();
    try { localStorage.removeItem(HOLD_KEY); } catch (e) {}
    try {
      var heldUrl = new URL(window.location.href);
      if (heldUrl.searchParams.has("wall")) {
        heldUrl.searchParams.delete("wall");
        history.replaceState(null, "", heldUrl.pathname + heldUrl.search + heldUrl.hash);
      }
    } catch (e) {}
  }
  state.panel = null;
  state.wallId = null;
  if (state.share) state.share.base = arrangementKey();
  var moves = [];
  var searchSeq = 0;
  var sceneRequest = 0;
  var placed = null;
  var activeScene = null;

  if (sessionHintDismissed()) {
    var hint = root.querySelector("[data-p2-hint]");
    if (hint) hint.hidden = true;
  } else if (touchUi()) {
    var hintLabel = root.querySelector("[data-p2-hint] span");
    if (hintLabel) hintLabel.textContent = "Tap a frame to change the print, frame, or mount.";
  }
  fillSelect(document.querySelector("[data-p2-style]"), Object.keys(STYLE_COLOURS), labelStyle);
  fillSelect(document.querySelector("[data-p2-mount-colour]"), Object.keys(MOUNT_COLOURS), function (name) { return name; });
  renderSceneButtons();
  bindControls();
  loadMissingPrints(function () {
    loadServerPlan(function () {
      render();
      boot();
      bootWalls();
      if (state.share && state.share.fromLink) {
        if (state.share.mine) setShareOpen(true);
        else setBarCollapsed(true);
      }
    });
  });

  if (window.ResizeObserver) new ResizeObserver(paint).observe(stage);
  else window.addEventListener("resize", paint);

  function render() {
    activeScene = sceneByHandle(state.scene) || scenes[0];
    state.scene = activeScene.handle;
    if (activeScene.configs.indexOf(state.config) === -1) state.config = activeScene.config;
    var wall = parseRect(activeScene.wallRect);
    var wallCm = parseFloat(activeScene.wallCm);
    var grid = parseConfig(state.config);
    var imageW = parseFloat(activeScene.imageWidth);
    var imageH = parseFloat(activeScene.imageHeight);
    if (!wall || !(wallCm > 0) || !grid || !(imageW > 0) || !(imageH > 0)) return;

    stage.style.aspectRatio = imageW + " / " + imageH;
    sceneImg.alt = activeScene.name;
    sceneImg.width = imageW;
    sceneImg.height = imageH;

    state.items = state.items.map(legalize);
    var slots = grid.rows * grid.cols;
    if (!(state.share && state.share.fromLink && !state.share.mine)) ensureFullGrid(slots);
    var hung = state.items.slice(0, slots);
    var drawable = [];
    hung.forEach(function (item, index) {
      var sized = resolve(item);
      if (!sized) return;
      sized.selectionIndex = index;
      drawable.push(sized);
    });
    placed = layout(drawable, grid, wall, wallCm, imageW / imageH, state.gap);

    hang.innerHTML = "";
    if (placed) {
      placed.items.forEach(function (item) { hang.appendChild(renderPrint(item)); });
    }

    renderSummary(slots);
    markSwitches();
    syncGlobalForm();
    root.setAttribute("data-p2-selection", JSON.stringify(state.items.map(setShape)));
    root.setAttribute("data-p2-slots", String(slots));
    persist();
    paint();
    revealScene();
    placePanel();
    placeHint();
    paintSaveLabel();
  }

  function renderPrint(item) {
    var node = document.createElement("article");
    node.className = "p2-print";
    if (state.focus === item.selectionIndex) node.classList.add("is-chosen");
    node.style.left = item.leftPct + "%";
    node.style.top = item.topPct + "%";
    node.style.width = item.widthPct + "%";
    node.style.height = item.heightPct + "%";
    node.dataset.index = String(item.selectionIndex);
    node.dataset.handle = item.handle;
    node.dataset.printCm = item.printW + "x" + item.printH;
    node.dataset.outerCm = item.outerW + "x" + item.outerH;

    var source = state.items[item.selectionIndex] || {};
    var plus = document.createElement("a");
    plus.className = "p2-plus";
    plus.href = "/products/" + encodeURIComponent(item.handle);
    plus.setAttribute("data-quick-view", "");
    plus.setAttribute("data-qv-handle", item.handle);
    plus.setAttribute("data-qv-style", source.frametype || "Classic");
    plus.setAttribute("data-qv-colour", source.frame || item.frameColour || "Oak");
    plus.setAttribute("data-qv-mount", source.mount || "Mounted");
    plus.setAttribute("data-qv-mount-colour", source.mountColour || item.mountColour || "White");
    plus.setAttribute("data-qv-size", source.size || "Medium");
    plus.setAttribute("aria-label", "View " + (item.title || item.handle));
    var disc = document.createElement("span");
    disc.className = "p2-plus-disc";
    disc.setAttribute("aria-hidden", "true");
    disc.textContent = "+";
    plus.appendChild(disc);
    node.appendChild(plus);
    var change = document.createElement("button");
    change.type = "button";
    change.className = "p2-change";
    change.textContent = "Change";
    change.setAttribute("data-p2-change", String(item.selectionIndex));
    node.appendChild(change);

    if (state.editing) {
      var remove = document.createElement("button");
      remove.type = "button";
      remove.className = "p2-remove";
      remove.textContent = "Remove";
      remove.setAttribute("data-remove", String(item.selectionIndex));
      node.appendChild(remove);
    }

    var frame = document.createElement("div");
    frame.className = "p2-frame";
    frame.setAttribute(styleAttr(item.frametype), colourKey(item.frameColour));
    frame.style.setProperty("--frame-w", (item.frameCm / item.outerW * 100) + "cqw");
    frame.style.setProperty("--mount-w", (item.mountCm / item.outerW * 100) + "cqw");
    var finish = FINISH[colourKey(item.frameColour)] || FINISH.oak;
    frame.style.setProperty("--frame-bg", "linear-gradient(135deg," + finish.out + "," + finish.mid + ")");
    frame.style.setProperty("--mount-bg", MOUNT_COLOURS[item.mountColour] || "#FFFFFF");

    var mount = document.createElement("div");
    mount.className = "p2-mount";
    if (!(item.mountCm > 0)) mount.classList.add("is-off");
    var piece = document.createElement("div");
    piece.className = "p2-piece";
    var img = document.createElement("img");
    img.alt = item.title + (item.artist ? " by " + item.artist : "");
    img.decoding = "async";
    piece.appendChild(img);
    mount.appendChild(piece);
    frame.appendChild(mount);
    ["t", "r", "b", "l"].forEach(function (side) {
      var rail = document.createElement("span");
      rail.className = "p2-rail p2-rail--" + side;
      rail.setAttribute("aria-hidden", "true");
      frame.appendChild(rail);
    });
    node.appendChild(frame);
    item.node = node;
    return node;
  }

  function renderSummary(slots) {
    var hung = state.items.slice(0, slots);
    var priced = priceSelection(hung);
    var summary = root.querySelector("[data-p2-summary]");
    var button = root.querySelector("[data-p2-basket]");
    if (priced.missing.length || !hung.length) {
      summary.textContent = priced.missing.length ? priced.missing.map(function (row) {
        return row.title + " has no " + row.size;
      }).join(". ") + "." : "";
      if (button) button.disabled = true;
    } else {
      summary.textContent = formatMoney(priced.total);
      if (button && button.textContent !== "Adding…") button.disabled = false;
    }
    root.setAttribute("data-p2-hung", hung.map(function (item) { return item.handle; }).join(","));
    root.setAttribute("data-p2-held-handles", state.items.slice(slots).map(function (item) { return item.handle; }).join(","));
  }

  function renderSceneButtons() {
    var scenesBox = root.querySelector("[data-p2-scenes]");
    var configsBox = root.querySelector("[data-p2-configs]");
    scenesBox.innerHTML = "";
    scenes.forEach(function (scene) {
      var button = document.createElement("button");
      button.type = "button";
      button.textContent = scene.name;
      button.setAttribute("data-scene", scene.handle);
      scenesBox.appendChild(button);
    });
    var editButton = root.querySelector("[data-p2-edit]");
    var undoButton = root.querySelector("[data-p2-undo]");
    var gapLabel = root.querySelector("[data-p2-gap-label]");
    var gapButtons = Array.prototype.slice.call(root.querySelectorAll("[data-gap]"));
    configsBox.innerHTML = "";
    var scene = sceneByHandle(state.scene) || scenes[0];
    scene.configs.forEach(function (config) {
      var button = document.createElement("button");
      button.type = "button";
      button.textContent = config;
      button.setAttribute("data-config", config);
      configsBox.appendChild(button);
    });
    if (editButton) configsBox.appendChild(editButton);
    if (undoButton) configsBox.appendChild(undoButton);
    if (gapLabel) configsBox.appendChild(gapLabel);
    gapButtons.forEach(function (button) { configsBox.appendChild(button); });
  }

  function markSwitches() {
    root.querySelectorAll("[data-scene]").forEach(function (button) {
      button.setAttribute("aria-pressed", button.getAttribute("data-scene") === state.scene ? "true" : "false");
    });
    root.querySelectorAll("[data-config]").forEach(function (button) {
      button.setAttribute("aria-pressed", button.getAttribute("data-config") === state.config ? "true" : "false");
    });
    root.querySelectorAll("[data-gap]").forEach(function (button) {
      button.setAttribute("aria-pressed", parseFloat(button.getAttribute("data-gap")) === state.gap ? "true" : "false");
    });
    var editButton = root.querySelector("[data-p2-edit]");
    var editNote = root.querySelector("[data-p2-edit-note]");
    if (editButton) editButton.setAttribute("aria-pressed", state.editing ? "true" : "false");
    if (editNote) editNote.hidden = !state.editing;
    var undoButton = root.querySelector("[data-p2-undo]");
    if (undoButton) undoButton.disabled = !moves.length;
    root.classList.toggle("is-editing", !!state.editing);
  }

  function bindControls() {
    var panel = root.querySelector("[data-p2-panel]");
    if (panel && panel.parentNode !== document.body) document.body.appendChild(panel);
    var hint = root.querySelector("[data-p2-hint]");
    if (hint && stage && hint.parentNode !== stage) stage.appendChild(hint);
    window.addEventListener("scroll", function () {
      placeHint();
      placeSharePanel();
      placeWallsPanel();
    }, { passive: true });
    window.addEventListener("resize", function () {
      placeSharePanel();
      placeWallsPanel();
      placeHint();
    });
    if (panel) {
      panel.addEventListener("click", function (event) {
        if (event.target.closest("[data-p2-panel-close]")) {
          state.panel = null;
          panel.hidden = true;
          return;
        }
        var add = event.target.closest("[data-p2-add]");
        if (add) {
          addCatalogPrint(add.getAttribute("data-p2-add"));
          return;
        }
        var pick = event.target.closest("[data-p2-pick]");
        if (!pick || state.focus == null) return;
        assignImage(state.focus, pick.getAttribute("data-p2-pick"));
        render();
      });
      panel.addEventListener("contextmenu", function (event) { event.preventDefault(); });
      bindPanelDrag(panel);
      var search = panel.querySelector("[data-p2-search]");
      var orient = panel.querySelector("[data-p2-orient]");
      if (search) {
        search.addEventListener("input", function () {
          clearTimeout(search.timer);
          var term = search.value;
          search.timer = setTimeout(function () { runSearch(term); }, 250);
        });
      }
      if (orient) orient.addEventListener("change", function () {
        runSearch(search ? search.value : "");
      });
    }
    document.addEventListener("pointerdown", function (event) {
      if (event.button === 2) return;
      var share = root.querySelector("[data-p2-share-panel]");
      if (share && !share.hidden && share.classList.contains("is-open") && !event.target.closest("[data-p2-share-panel]") && !event.target.closest("[data-p2-comments]")) {
        setShareOpen(false);
      }
      var walls = root.querySelector("[data-p2-walls]");
      if (walls && !walls.hidden && walls.classList.contains("is-open") && !event.target.closest("[data-p2-walls]") && !event.target.closest("[data-p2-walls-open]")) {
        setWallsOpen(false);
      }
      if (!state.panel) return;
      if (event.target.closest("[data-p2-panel]")) return;
      state.panel = null;
      if (panel) panel.hidden = true;
    });
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      var login = document.querySelector("[data-p2-login]");
      if (login && !login.hidden) {
        closeLoginAsk();
        return;
      }
      var walls = root.querySelector("[data-p2-walls]");
      if (walls && !walls.hidden && walls.classList.contains("is-open")) {
        setWallsOpen(false);
        return;
      }
      var share = root.querySelector("[data-p2-share-panel]");
      if (share && !share.hidden && share.classList.contains("is-open")) {
        setShareOpen(false);
        return;
      }
      if (!state.panel) return;
      state.panel = null;
      if (panel) panel.hidden = true;
    });
    root.addEventListener("contextmenu", function (event) {
      var print = event.target.closest(".p2-print");
      if (!print || event.target.closest(".p2-tip")) return;
      event.preventDefault();
      openFramePanel(parseInt(print.dataset.index, 10), event.clientX, event.clientY);
    });
    root.addEventListener("click", function (event) {
      if (event.target.closest("[data-p2-hint-close]")) {
        dismissHint();
        return;
      }
      if (event.target.closest("[data-p2-comments]")) {
        var comments = root.querySelector("[data-p2-share-panel]");
        setShareOpen(!(comments && !comments.hidden));
        return;
      }
      if (event.target.closest("[data-p2-bar-toggle]")) {
        var bar = root.querySelector("[data-p2-bar]");
        setBarCollapsed(!(bar && bar.classList.contains("is-collapsed")));
        return;
      }
      if (event.target.closest("[data-p2-basket]")) {
        addAllToBasket();
        return;
      }
      if (event.target.closest("[data-p2-undo]")) {
        undoMove();
        return;
      }
      if (event.target.closest("[data-p2-save]")) {
        saveSceneImage();
        return;
      }
      if (event.target.closest("[data-p2-walls-open]")) {
        var wallsPanel = root.querySelector("[data-p2-walls]");
        setWallsOpen(!(wallsPanel && wallsPanel.classList.contains("is-open")));
        return;
      }
      if (event.target.closest("[data-p2-walls-close]")) {
        setWallsOpen(false);
        return;
      }
      if (event.target.closest("[data-p2-share-close]")) {
        setShareOpen(false);
        return;
      }
      if (event.target.closest("[data-p2-walls-filter]")) {
        toggleWallFilter();
        return;
      }
      if (event.target.closest("[data-p2-walls-save]")) {
        if (!signedIn()) {
          askLoginToSave();
          return;
        }
        saveOwnerWall(false);
        return;
      }
      var wallPick = event.target.closest("[data-p2-walls-pick]");
      if (wallPick) {
        openOwnerWall(wallPick.getAttribute("data-p2-walls-pick"));
        return;
      }
      var wallRename = event.target.closest("[data-p2-walls-rename]");
      if (wallRename) {
        beginRenameWall(wallRename.getAttribute("data-p2-walls-rename"));
        return;
      }
      var wallRenameSave = event.target.closest("[data-p2-walls-rename-save]");
      if (wallRenameSave) {
        var renameId = wallRenameSave.getAttribute("data-p2-walls-rename-save");
        var renameInput = root.querySelector('[data-p2-walls-rename-input="' + renameId + '"]');
        renameOwnerWall(renameId, renameInput && renameInput.value);
        return;
      }
      var wallCopy = event.target.closest("[data-p2-walls-copy]");
      if (wallCopy) {
        duplicateOwnerWall(wallCopy.getAttribute("data-p2-walls-copy"));
        return;
      }
      var wallLink = event.target.closest("[data-p2-walls-link]");
      if (wallLink) {
        copyOwnerWallLink(wallLink.getAttribute("data-p2-walls-link"));
        return;
      }
      var wallRemove = event.target.closest("[data-p2-walls-remove]");
      if (wallRemove) {
        deleteOwnerWall(wallRemove.getAttribute("data-p2-walls-remove"));
        return;
      }
      var wallRestore = event.target.closest("[data-p2-walls-restore]");
      if (wallRestore) {
        restoreOwnerWall(wallRestore.getAttribute("data-p2-walls-restore"));
        return;
      }
      if (event.target.closest("[data-p2-share]")) {
        shareWall();
        return;
      }
      if (event.target.closest("[data-p2-share-send]")) {
        var noteBox = root.querySelector("[data-p2-share-note]");
        var noteText = noteBox && noteBox.value;
        if (!String(noteText || "").trim()) {
          if (noteBox) noteBox.focus();
          return;
        }
        addShareNote(noteText);
        return;
      }
      if (event.target.closest("[data-p2-share-copy]")) {
        copyShareLink();
        return;
      }
      if (event.target.closest("[data-p2-share-approve]")) {
        setShareStatus("approved");
        return;
      }
      if (event.target.closest("[data-p2-share-reject]")) {
        setShareStatus("rejected");
        return;
      }
      var noteEdit = event.target.closest("[data-p2-note-edit]");
      if (noteEdit) {
        editShareNote(parseInt(noteEdit.getAttribute("data-p2-note-edit"), 10));
        return;
      }
      var noteDelete = event.target.closest("[data-p2-note-delete]");
      if (noteDelete) {
        deleteShareNote(parseInt(noteDelete.getAttribute("data-p2-note-delete"), 10));
        return;
      }
      var noteSave = event.target.closest("[data-p2-note-save]");
      if (noteSave) {
        var editing = noteSave.closest("li");
        var field = editing && editing.querySelector("textarea");
        saveShareNote(parseInt(noteSave.getAttribute("data-p2-note-save"), 10), field && field.value);
        return;
      }
      if (event.target.closest("[data-p2-note-cancel]")) {
        paintShare();
        return;
      }
      var sceneButton = event.target.closest("[data-scene]");
      if (sceneButton) {
        state.panel = null;
        switchScene(sceneButton.getAttribute("data-scene"));
        return;
      }
      var gapButton = event.target.closest("[data-gap]");
      if (gapButton) {
        state.panel = null;
        state.gap = gapSize(gapButton.getAttribute("data-gap"));
        render();
        return;
      }
      var configButton = event.target.closest("[data-config]");
      if (configButton) {
        state.panel = null;
        state.config = configButton.getAttribute("data-config");
        state.focus = null;
        renderSceneButtons();
        render();
        return;
      }
      var editButton = event.target.closest("[data-p2-edit]");
      if (editButton) {
        state.panel = null;
        state.editing = !state.editing;
        state.focus = null;
        render();
        return;
      }
      var heldButton = event.target.closest("[data-held]");
      if (heldButton) {
        swapWithHung(parseInt(heldButton.getAttribute("data-held"), 10));
        return;
      }
      var removeButton = event.target.closest("[data-remove]");
      if (removeButton) {
        event.stopPropagation();
        removeHung(parseInt(removeButton.getAttribute("data-remove"), 10));
        return;
      }
      if (event.target.closest("[data-quick-view]")) return;
      var change = event.target.closest("[data-p2-change]");
      if (change) {
        openFramePanel(parseInt(change.getAttribute("data-p2-change"), 10), event.clientX, event.clientY);
        return;
      }
      var print = event.target.closest(".p2-print");
      if (print) {
        var index = parseInt(print.dataset.index, 10);
        if (state.editing) {
          state.panel = null;
          reorderClick(index);
          render();
          return;
        }
        if (touchUi()) {
          openFramePanel(index, event.clientX, event.clientY);
          return;
        }
        state.panel = null;
        state.focus = state.focus === index ? null : index;
        render();
        return;
      }
      if (event.target.closest("[data-p2-hang]") && state.focus != null) {
        state.panel = null;
        state.focus = null;
        render();
      }
    });

    document.querySelector("[data-p2-style]").addEventListener("change", onGlobalChange);
    document.querySelector("[data-p2-colour]").addEventListener("change", onGlobalChange);
    document.querySelector("[data-p2-mount]").addEventListener("change", onGlobalChange);
    document.querySelector("[data-p2-mount-colour]").addEventListener("change", onGlobalChange);
    document.querySelector("[data-p2-size]").addEventListener("change", onSizeChange);
    document.querySelector("[data-p2-scope]").addEventListener("change", syncGlobalForm);
    try {
      if (sessionStorage.getItem("planner2.bar") === "hidden") setBarCollapsed(true);
    } catch (error) {}
  }

  function touchUi() {
    return window.matchMedia("(hover: none), (pointer: coarse)").matches;
  }

  function openFramePanel(index, x, y) {
    if (!(index >= 0) || !state.items[index]) return;
    state.focus = index;
    state.panel = { x: x, y: y };
    var scope = document.querySelector("[data-p2-scope]");
    if (scope) scope.value = "one";
    render();
  }

  function hungItems() {
    return state.items.slice(0, currentSlots());
  }

  function setBarCollapsed(collapsed) {
    var bar = root.querySelector("[data-p2-bar]");
    var toggle = root.querySelector("[data-p2-bar-toggle]");
    if (!bar || !toggle) return;
    bar.classList.toggle("is-collapsed", !!collapsed);
    if (collapsed) setWallsOpen(false);
    toggle.setAttribute("aria-expanded", collapsed ? "false" : "true");
    toggle.textContent = collapsed ? "Show" : "Hide";
    try { sessionStorage.setItem("planner2.bar", collapsed ? "hidden" : "open"); } catch (error) {}
    syncCommentCue();
    placeSharePanel();
    placeWallsPanel();
    placeHint();
    requestAnimationFrame(placeHint);
  }

  function basketLine(item) {
    var product = products[item.handle];
    var variant = product && findVariant(product, item);
    if (!variant || !variant.id) return null;
    return {
      id: variant.id,
      quantity: 1,
      properties: {
        "Frame style": item.frametype,
        "Frame colour": item.frame,
        "Mount": item.mount,
        "Mount colour": item.mountColour,
        "Size": item.size
      }
    };
  }

  function addAllToBasket() {
    var button = root.querySelector("[data-p2-basket]");
    var wall = hungItems();
    if (!button || button.disabled || !wall.length) return;
    button.disabled = true;
    button.textContent = "Adding…";
    var missing = wall.filter(function (item) { return !basketLine(item); });
    var loads = missing.map(function (item) {
      return fetch("/products/" + encodeURIComponent(item.handle) + ".js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      }).then(function (res) {
        if (!res.ok) throw new Error("missing");
        return res.json();
      }).then(catalogueFromAjax).then(function (product) {
        if (product) products[product.handle] = product;
      }).catch(function () {});
    });
    Promise.all(loads).then(function () {
      var items = [];
      var blocked = false;
      wall.forEach(function (item) {
        var line = basketLine(item);
        if (!line) blocked = true;
        else items.push(line);
      });
      if (blocked || items.length !== wall.length) {
        button.textContent = "Add wall to basket";
        button.disabled = true;
        var summary = root.querySelector("[data-p2-summary]");
        if (summary) summary.textContent = "No matching frame";
        return;
      }
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items: items })
      }).then(function (res) {
        if (!res.ok) throw new Error("cart");
        window.location.href = "/cart";
      }).catch(function () {
        button.disabled = false;
        button.textContent = "Add wall to basket";
        var note = root.querySelector("[data-p2-summary]");
        if (note) note.textContent = "Could not add these prints";
      });
    });
  }

  function bindPanelDrag(panel) {
    var head = panel.querySelector("[data-p2-panel-drag]");
    if (!head) return;
    head.addEventListener("pointerdown", function (event) {
      if (event.button !== 0) return;
      if (event.target.closest("a, button, input, select")) return;
      var startX = event.clientX;
      var startY = event.clientY;
      var origin = panel.getBoundingClientRect();
      head.classList.add("is-dragging");
      function move(ev) {
        var x = origin.left + ev.clientX - startX;
        var y = origin.top + ev.clientY - startY;
        var pad = 8;
        x = Math.max(pad, Math.min(x, window.innerWidth - panel.offsetWidth - pad));
        y = Math.max(pad, Math.min(y, window.innerHeight - 48));
        panel.style.left = x + "px";
        panel.style.top = y + "px";
        if (state.panel) {
          state.panel.x = x;
          state.panel.y = y;
        }
      }
      function up() {
        head.classList.remove("is-dragging");
        window.removeEventListener("pointermove", move);
        window.removeEventListener("pointerup", up);
      }
      window.addEventListener("pointermove", move);
      window.addEventListener("pointerup", up);
      event.preventDefault();
    });
  }

  function placeHint() {
    var hint = stage && stage.querySelector("[data-p2-hint]");
    if (!hint || hint.hidden) return;
    var bar = root.querySelector("[data-p2-bar]");
    if (!bar) {
      hint.style.visibility = "";
      return;
    }
    var hintBox = hint.getBoundingClientRect();
    var barTop = bar.getBoundingClientRect().top;
    hint.style.visibility = hintBox.bottom > barTop - 6 ? "hidden" : "";
  }

  function stylesFor(product) {
    var seen = [];
    var order = ["classic", "deep classic", "swoop", "venice"];
    (product && product.variants || []).forEach(function (variant) {
      var style = styleKey(variant.frametype);
      var mount = mountKey(variant.mount);
      if (!style || !STYLE_COLOURS[style]) return;
      if (mount !== "mounted" && mount !== "no mount") return;
      if (!printCm(variant.size)) return;
      if (seen.indexOf(style) === -1) seen.push(style);
    });
    return order.filter(function (style) { return seen.indexOf(style) !== -1; });
  }

  function mountsFor(product, style) {
    var want = styleKey(style);
    var mounted = false;
    var bare = false;
    (product && product.variants || []).forEach(function (variant) {
      if (styleKey(variant.frametype) !== want || !printCm(variant.size)) return;
      var mount = mountKey(variant.mount);
      if (mount === "mounted") mounted = true;
      if (mount === "no mount") bare = true;
    });
    var list = [];
    if (mounted) list.push("Mounted");
    if (bare) list.push("No mount");
    return list;
  }

  function optionProducts() {
    var scope = document.querySelector("[data-p2-scope]");
    var one = scope && scope.value === "one" && state.focus != null && state.items[state.focus];
    var handles = [];
    var list = [];
    function add(item) {
      var product = item && products[item.handle];
      if (!product || handles.indexOf(product.handle) !== -1) return;
      handles.push(product.handle);
      list.push(product);
    }
    if (one) add(state.items[state.focus]);
    else state.items.forEach(add);
    return list;
  }

  function unionStyles(list) {
    var seen = [];
    list.forEach(function (product) {
      stylesFor(product).forEach(function (style) {
        if (seen.indexOf(style) === -1) seen.push(style);
      });
    });
    return ["classic", "deep classic", "swoop", "venice"].filter(function (style) {
      return seen.indexOf(style) !== -1;
    });
  }

  function unionMounts(list, style) {
    var names = [];
    list.forEach(function (product) {
      mountsFor(product, style).forEach(function (mount) {
        if (names.indexOf(mount) === -1) names.push(mount);
      });
    });
    return ["Mounted", "No mount"].filter(function (mount) { return names.indexOf(mount) !== -1; });
  }

  function productSupports(product, finish) {
    return !!(product && sizeLabelFor(product, finish));
  }

  function legalize(item) {
    var product = item && products[item.handle];
    if (!product) return item;
    if (productSupports(product, item)) return fitSize(item);
    var styles = stylesFor(product);
    var preferred = styleKey(item.frametype);
    var style = styles.indexOf(preferred) !== -1 ? preferred : (styles[0] || "classic");
    var mounts = mountsFor(product, style);
    var preferredMount = mountKey(item.mount) === "no mount" ? "No mount" : "Mounted";
    var mount = mounts.indexOf(preferredMount) !== -1 ? preferredMount : (mounts[0] || "Mounted");
    var colours = STYLE_COLOURS[style] || [];
    var frame = colours.indexOf(item.frame) === -1 ? STYLE_DEFAULT[style] : item.frame;
    var next = setShape({
      handle: item.handle,
      size: item.size,
      frametype: labelStyle(style),
      frame: frame,
      mount: mount,
      mountColour: item.mountColour
    });
    return next ? fitSize(next) : item;
  }

  function sizesFor(product, finish) {
    if (!product || !finish) return [];
    var wantStyle = styleKey(finish.frametype);
    var wantMount = mountKey(finish.mount);
    if (!wantStyle || (wantMount !== "mounted" && wantMount !== "no mount")) return [];
    var labels = [];
    SIZE_CHOICES.forEach(function (size) {
      var ok = (product.variants || []).some(function (variant) {
        return tierOf(variant.size) === size.tier && styleKey(variant.frametype) === wantStyle && mountKey(variant.mount) === wantMount && printCm(variant.size);
      });
      if (ok) labels.push(size.label);
    });
    return labels;
  }

  function tierAvailable(labels, size) {
    var tier = tierOf(size);
    if (!tier) return false;
    return labels.some(function (label) { return tierOf(label) === tier; });
  }

  function fitSize(item) {
    return item;
  }

  function refreshSizes(item) {
    var select = document.querySelector("[data-p2-size]");
    if (!select) return;
    var labels = sizesFor(item && products[item.handle], item);
    if (!labels.length) labels = item && item.size ? [item.size] : ["Medium"];
    if (item && printCm(item.size) && tierAvailable(labels, item.size)) {
      var exact = item.size;
      labels = labels.map(function (label) { return tierOf(label) === tierOf(exact) ? exact : label; });
    }
    fillSelect(select, labels, function (name) { return name; });
    select.value = item && labels.indexOf(item.size) !== -1 ? item.size : labels[0];
  }

  function runSearch(term) {
    var box = document.querySelector("[data-p2-search-results]");
    if (!box) return;
    var seq = ++searchSeq;
    term = String(term || "").trim();
    var orient = (document.querySelector("[data-p2-orient]") || {}).value || "";
    if (term.length < 2) {
      box.hidden = true;
      box.innerHTML = "";
      return;
    }
    var url = "/search/suggest.json?q=" + encodeURIComponent(term) + "&resources[type]=product&resources[limit]=8&resources[options][fields]=title,vendor,tag";
    fetch(url, { credentials: "same-origin", headers: { Accept: "application/json" } }).then(function (res) {
      if (!res.ok) throw new Error("search");
      return res.json();
    }).then(function (data) {
      if (seq !== searchSeq) return null;
      var list = (((data || {}).resources || {}).results || {}).products || [];
      if (!orient) return list;
      return Promise.all(list.map(function (product) {
        var image = product.image || product.featured_image;
        if (image && typeof image !== "string") image = image.url || image.src || "";
        if (!image) return null;
        return imageShape(image).then(function (shape) { return shape === orient ? product : null; });
      })).then(function (rows) { return rows.filter(Boolean); });
    }).then(function (list) {
      if (seq !== searchSeq || !list) return;
      box.innerHTML = "";
      if (!list.length) {
        box.hidden = false;
        box.textContent = "No prints found";
        return;
      }
      list.forEach(function (product) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "p2-search-hit";
        button.setAttribute("data-p2-add", product.handle);
        var image = product.image || product.featured_image;
        if (image && typeof image !== "string") image = image.url || image.src || "";
        if (image) {
          var img = document.createElement("img");
          img.alt = "";
          img.src = withWidth(image, 72);
          button.appendChild(img);
        }
        var label = document.createElement("span");
        label.textContent = "Add " + (product.title || product.handle);
        button.appendChild(label);
        box.appendChild(button);
      });
      box.hidden = false;
    }).catch(function () {
      if (seq !== searchSeq) return;
      box.hidden = false;
      box.textContent = "No prints found";
    });
  }

  function imageShape(src) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.onload = function () {
        var ratio = img.naturalWidth / (img.naturalHeight || 1);
        if (ratio < 0.98) resolve("portrait");
        else if (ratio <= 1.05) resolve("square");
        else resolve("landscape");
      };
      img.onerror = function () { resolve(""); };
      img.src = src;
    });
  }

  function catalogueFromAjax(raw) {
    if (!raw || !raw.handle) return null;
    var terms = String(root.getAttribute("data-excluded") || "").toLowerCase().split("|");
    var options = (raw.options || []).map(function (option) { return typeof option === "string" ? option : option.name; });
    var variants = [];
    (raw.variants || []).forEach(function (variant) {
      var size = "";
      var frame = "";
      var mount = "";
      options.forEach(function (name, index) {
        var value = variant["option" + (index + 1)] || "";
        if (name === "Size") size = value;
        else if (name === "Frame") frame = value;
        else if (name === "Mount") mount = value;
      });
      var lowSize = String(size).toLowerCase();
      var lowMount = String(mount).toLowerCase();
      var skip = terms.some(function (term) {
        term = term.trim();
        return term && (lowSize.indexOf(term) !== -1 || lowMount.indexOf(term) !== -1);
      });
      if (skip || !size || !frame || !mount) return;
      variants.push({ size: size, frametype: frame, mount: mount, price: variant.price, id: variant.id });
    });
    if (!variants.length) return null;
    var image = raw.featured_image;
    if (image && typeof image !== "string") image = image.src || image.url || "";
    var width = raw.featured_image && raw.featured_image.width;
    return {
      handle: raw.handle,
      title: raw.title || raw.handle,
      artist: raw.vendor || "",
      image: image || "",
      imageWidth: width || 1600,
      variants: variants
    };
  }

  function addCatalogPrint(handle) {
    var known = products[handle];
    var ready = known ? Promise.resolve(known) : fetch("/products/" + encodeURIComponent(handle) + ".js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    }).then(function (res) {
      if (!res.ok) throw new Error("missing");
      return res.json();
    }).then(catalogueFromAjax);
    ready.then(function (product) {
      if (!product) return;
      products[product.handle] = product;
      if (!catalogue.some(function (entry) { return entry.handle === product.handle; })) catalogue.push(product);
      var finish = state.global;
      var item = legalize(setShape({
        handle: product.handle,
        size: sizeLabelFor(product, finish) || "Medium",
        frametype: finish.frametype,
        frame: finish.frame,
        mount: finish.mount,
        mountColour: finish.mountColour
      }));
      if (!item || !resolve(item)) return;
      state.items.push(item);
      state.overrides.push(false);
      var images = document.querySelector("[data-p2-panel-images]");
      if (images) images.innerHTML = "";
      var results = document.querySelector("[data-p2-search-results]");
      if (results) {
        results.hidden = true;
        results.innerHTML = "";
      }
      var search = document.querySelector("[data-p2-search]");
      if (search) search.value = "";
      render();
    }).catch(function () {});
  }

  function sessionHintDismissed() {
    try { return sessionStorage.getItem(HINT_KEY) === "1"; } catch (e) { return false; }
  }

  function dismissHint() {
    var hint = root.querySelector("[data-p2-hint]");
    if (hint) hint.hidden = true;
    try { sessionStorage.setItem(HINT_KEY, "1"); } catch (e) {}
  }

  function assignImage(index, handle) {
    var current = state.items[index];
    var product = products[handle];
    if (!current || !product) return;
    var item = legalize(setShape({
      handle: handle,
      size: sizeLabelFor(product, current) || current.size || "Medium",
      frametype: current.frametype,
      frame: current.frame,
      mount: current.mount,
      mountColour: current.mountColour
    }));
    if (!item || !resolve(item)) return;
    state.items[index] = item;
  }

  function fillPanelImages() {
    var box = document.querySelector("[data-p2-panel-images]");
    if (!box || box.childElementCount) return;
    catalogue.forEach(function (product) {
      if (!product || !product.image) return;
      var button = document.createElement("button");
      button.type = "button";
      button.setAttribute("data-p2-pick", product.handle);
      button.setAttribute("aria-label", product.title || product.handle);
      var img = document.createElement("img");
      img.alt = "";
      img.src = withWidth(product.image, 120);
      button.appendChild(img);
      box.appendChild(button);
    });
  }

  function placePanel() {
    var panel = document.querySelector("[data-p2-panel]");
    if (!panel) return;
    if (!state.panel || state.focus == null || !state.items[state.focus]) {
      panel.hidden = true;
      return;
    }
    fillPanelImages();
    var item = state.items[state.focus];
    var product = products[item.handle];
    var title = panel.querySelector("[data-p2-panel-title]");
    if (title) {
      title.textContent = (product && product.title) || item.handle;
      title.href = "/products/" + encodeURIComponent(item.handle);
    }
    panel.querySelectorAll("[data-p2-pick]").forEach(function (button) {
      button.setAttribute("aria-pressed", button.getAttribute("data-p2-pick") === item.handle ? "true" : "false");
    });
    panel.hidden = false;
    var pad = 12;
    var width = panel.offsetWidth || 560;
    var height = panel.offsetHeight || 360;
    var x = state.panel.x;
    var y = state.panel.y;
    if (x + width > window.innerWidth - pad) x = window.innerWidth - width - pad;
    if (y + height > window.innerHeight - pad) y = window.innerHeight - height - pad;
    panel.style.left = Math.max(pad, x) + "px";
    panel.style.top = Math.max(pad, y) + "px";
    var chosen = panel.querySelector("[data-p2-pick][aria-pressed='true']");
    var scroller = panel.querySelector("[data-p2-panel-images]");
    if (chosen && scroller) {
      var box = scroller.getBoundingClientRect();
      var thumb = chosen.getBoundingClientRect();
      if (thumb.top < box.top) scroller.scrollTop -= box.top - thumb.top;
      else if (thumb.bottom > box.bottom) scroller.scrollTop += thumb.bottom - box.bottom;
    }
  }

  function onGlobalChange() {
    var offered = optionProducts();
    var style = styleKey(document.querySelector("[data-p2-style]").value) || "classic";
    var styles = offered.length ? unionStyles(offered) : ["classic", "deep classic", "swoop", "venice"];
    if (styles.indexOf(style) === -1) style = styles[0] || "classic";
    refreshColours(style);
    var mounts = offered.length ? unionMounts(offered, style) : ["Mounted", "No mount"];
    if (!mounts.length) mounts = ["Mounted"];
    var mountSelect = document.querySelector("[data-p2-mount]");
    fillSelect(mountSelect, mounts, function (name) { return name; });
    var next = {
      frametype: labelStyle(style),
      frame: document.querySelector("[data-p2-colour]").value,
      mount: mountSelect.value,
      mountColour: document.querySelector("[data-p2-mount-colour]").value
    };
    if (!STYLE_COLOURS[style] || STYLE_COLOURS[style].indexOf(next.frame) === -1) {
      next.frame = STYLE_DEFAULT[style];
    }
    next = finishShape(next) || state.global;
    if (document.querySelector("[data-p2-scope]").value === "one" && state.focus != null && state.items[state.focus]) {
      var focused = state.items[state.focus];
      if (!products[focused.handle] || productSupports(products[focused.handle], next)) {
        state.items[state.focus] = fitSize(Object.assign(setShape(focused), next));
        state.overrides[state.focus] = true;
      }
    } else {
      state.global = next;
      state.items.forEach(function (item, index) {
        if (state.overrides[index]) return;
        var product = products[item.handle];
        if (product && !productSupports(product, next)) return;
        state.items[index] = fitSize(Object.assign(setShape(item), next));
      });
    }
    render();
  }

  function onSizeChange() {
    var size = document.querySelector("[data-p2-size]").value;
    var one = document.querySelector("[data-p2-scope]").value === "one" && state.focus != null && state.items[state.focus];
    function apply(item) {
      var product = products[item.handle];
      var labels = sizesFor(product, item);
      if (product && labels.indexOf(size) === -1 && !tierAvailable(labels, size)) return;
      item.size = size;
    }
    if (one) apply(state.items[state.focus]);
    else state.items.forEach(apply);
    render();
  }

  function switchScene(handle) {
    var scene = sceneByHandle(handle);
    if (!scene || scene.handle === state.scene) return;
    state.scene = scene.handle;
    if (scene.configs.indexOf(state.config) === -1) state.config = scene.config;
    state.focus = null;
    renderSceneButtons();
    render();
  }

  function reorderClick(index) {
    var slots = currentSlots();
    if (!(index >= 0) || index >= slots) return;
    if (state.focus === index) {
      state.focus = null;
      return;
    }
    if (state.focus != null && state.focus < slots) {
      exchange(state.focus, index);
      state.focus = null;
      return;
    }
    state.focus = index;
  }

  function swapWithHung(heldIndex) {
    var slots = currentSlots();
    if (!(heldIndex >= slots) || heldIndex >= state.items.length) return;
    var hungIndex = state.focus != null && state.focus < slots ? state.focus : slots - 1;
    if (!(hungIndex >= 0) || hungIndex >= state.items.length) return;
    exchange(hungIndex, heldIndex);
    state.focus = hungIndex;
    render();
  }

  function removeHung(index) {
    var slots = currentSlots();
    if (!(index >= 0) || index >= slots || index >= state.items.length) return;
    rememberMove();
    if (state.items.length > slots) {
      var promoted = state.items.splice(slots, 1)[0];
      var promotedFlag = state.overrides.splice(slots, 1)[0];
      state.items.splice(index, 1, promoted);
      state.overrides.splice(index, 1, promotedFlag);
    } else {
      state.items.splice(index, 1);
      state.overrides.splice(index, 1);
    }
    state.focus = null;
    render();
  }

  function exchange(a, b) {
    rememberMove();
    var item = state.items[a];
    state.items[a] = state.items[b];
    state.items[b] = item;
    var flag = state.overrides[a];
    state.overrides[a] = state.overrides[b];
    state.overrides[b] = flag;
  }

  function resolve(item) {
    var product = products[item.handle];
    if (!product) return null;
    var variant = findVariant(product, item);
    if (!variant) return null;
    var sheet = printCm(variant.size);
    var style = styleKey(item.frametype);
    var tier = tierOf(variant.size);
    var frameCm = FRAME_FACE_CM[style];
    var mountName = mountKey(item.mount);
    if (!sheet || frameCm == null || (mountName !== "mounted" && mountName !== "no mount")) return null;
    var mountCm = mountName === "no mount" ? 0 : MOUNT_CM[tier];
    if (mountCm == null) return null;
    var border = frameCm + mountCm;
    return {
      handle: item.handle,
      title: product.title,
      artist: product.artist,
      image: product.image,
      imageWidth: parseFloat(product.imageWidth) || 0,
      printW: sheet.w,
      printH: sheet.h,
      frameCm: frameCm,
      mountCm: mountCm,
      outerW: sheet.w + 2 * border,
      outerH: sheet.h + 2 * border,
      frametype: style,
      frameColour: item.frame,
      mountColour: item.mountColour,
      price: variant.price
    };
  }

  function findVariant(product, item) {
    var wantStyle = styleKey(item.frametype);
    var wantMount = mountKey(item.mount);
    var wantTier = tierOf(item.size);
    var wantDims = printCm(item.size);
    var found = null;
    (product.variants || []).forEach(function (variant) {
      if (found) return;
      if (tierOf(variant.size) !== wantTier) return;
      if (wantDims) {
        var got = printCm(variant.size);
        if (!got || got.w !== wantDims.w || got.h !== wantDims.h) return;
      }
      if (styleKey(variant.frametype) !== wantStyle) return;
      if (mountKey(variant.mount) !== wantMount) return;
      found = variant;
    });
    return found;
  }

  function priceSelection(list) {
    var rows = list || hungItems();
    var total = 0;
    var missing = [];
    rows.forEach(function (item) {
      var product = products[item.handle];
      var variant = product && findVariant(product, item);
      if (!variant) {
        missing.push({
          title: (product && product.title) || item.handle,
          size: item.size || "that size"
        });
        return;
      }
      total += variant.price;
    });
    return { total: total, missing: missing };
  }

  function layout(list, grid, rect, widthCm, aspect, gapCm) {
    var gap = gapSize(gapCm);
    var heightCm = widthCm * (rect.h / rect.w) / aspect;
    if (!list.length) return { items: [], scale: 1, heightCm: heightCm, wall: rect, wallCm: widthCm };
    var rows = [];
    for (var r = 0; r < grid.rows; r++) {
      var row = list.slice(r * grid.cols, (r + 1) * grid.cols);
      if (row.length) rows.push(row);
    }
    var groupW = 0;
    var groupH = 0;
    rows.forEach(function (row, index) {
      groupW = Math.max(groupW, rowWidth(row, gap));
      groupH += rowHeight(row);
      if (index) groupH += gap;
    });
    var scale = 1;
    if (groupW > widthCm || groupH > heightCm) scale = Math.min(widthCm / groupW, heightCm / groupH);
    var usedW = groupW * scale;
    var usedH = groupH * scale;
    var originX = (widthCm - usedW) / 2;
    var y = (heightCm - usedH) / 2;
    var items = [];
    rows.forEach(function (row) {
      var rw = rowWidth(row, gap) * scale;
      var rh = rowHeight(row) * scale;
      var x = originX + (usedW - rw) / 2;
      var mid = y + rh / 2;
      row.forEach(function (print) {
        var ow = print.outerW * scale;
        var oh = print.outerH * scale;
        items.push(Object.assign({}, print, {
          xCm: x,
          yCm: mid - oh / 2,
          widthPct: (ow / widthCm) * rect.w,
          heightPct: (oh / heightCm) * rect.h,
          leftPct: rect.x + (x / widthCm) * rect.w,
          topPct: rect.y + ((mid - oh / 2) / heightCm) * rect.h
        }));
        x += ow + gap * scale;
      });
      y += rh + gap * scale;
    });
    return { items: items, scale: scale, heightCm: heightCm, wall: rect, wallCm: widthCm };
  }

  function boot() {
    var tries = 0;
    function tick() {
      if (stage.clientWidth > 0) {
        paint();
        return;
      }
      if (tries++ < 8) requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function paint() {
    if (!placed || !activeScene) return;
    var stageW = stage.clientWidth;
    if (!(stageW > 0)) return;
    paintShadows(activeScene.light);
    var dpr = window.devicePixelRatio || 1;
    var scenePx = Math.min(parseFloat(activeScene.imageWidth) || stageW, Math.max(1, Math.ceil(stageW * dpr)));
    var nextSrc = withWidth(activeScene.image, scenePx);
    if (scenePx !== sceneRequest || sceneImg.getAttribute("data-master") !== activeScene.image) {
      sceneRequest = scenePx;
      sceneImg.setAttribute("data-master", activeScene.image);
      if (sceneImg.src !== nextSrc) sceneImg.src = nextSrc;
    }
    placed.items.forEach(function (item) {
      var img = item.node && item.node.querySelector(".p2-piece img");
      if (!img) return;
      var framePx = (item.widthPct / 100) * stageW;
      var piecePx = framePx * (item.printW / item.outerW);
      var want = Math.min(item.imageWidth || piecePx, Math.max(1, Math.ceil(piecePx * dpr)));
      var prev = parseInt(img.getAttribute("data-req") || "0", 10);
      if (Math.abs(want - prev) < Math.max(8, prev * 0.08) && img.getAttribute("src")) return;
      img.setAttribute("data-req", String(want));
      img.src = withWidth(item.image, want);
    });
    placeHint();
  }

  function revealScene() {
    var images = [sceneImg].concat(placed ? placed.items.map(function (item) {
      return item.node.querySelector(".p2-piece img");
    }) : []);
    Promise.all(images.map(decode)).then(function () { stage.classList.add("is-ready"); });
  }

  function paintShadows(light) {
    var fromRight = String(light).trim().toLowerCase() === "right";
    stage.setAttribute("data-light", fromRight ? "right" : "left");
    stage.style.setProperty("--fv-lx", fromRight ? "-1" : "1");
  }

  function styleAttr(style) {
    if (style === "deep classic") return "data-deep-classic";
    if (style === "swoop") return "data-swoop";
    if (style === "venice") return "data-venice";
    return "data-classic";
  }

  function syncGlobalForm() {
    var source = state.global;
    if (document.querySelector("[data-p2-scope]").value === "one" && state.focus != null && state.items[state.focus]) {
      source = state.items[state.focus];
    }
    var offered = optionProducts();
    var styles = offered.length ? unionStyles(offered) : ["classic", "deep classic", "swoop", "venice"];
    if (!styles.length) styles = ["classic"];
    var style = styleKey(source.frametype) || styles[0];
    if (styles.indexOf(style) === -1) style = styles[0];
    fillSelect(document.querySelector("[data-p2-style]"), styles, labelStyle);
    document.querySelector("[data-p2-style]").value = style;
    refreshColours(style);
    var colour = STYLE_COLOURS[style].indexOf(source.frame) === -1 ? STYLE_DEFAULT[style] : source.frame;
    document.querySelector("[data-p2-colour]").value = colour;
    var mounts = offered.length ? unionMounts(offered, style) : ["Mounted", "No mount"];
    if (!mounts.length) mounts = ["Mounted"];
    var mountName = mountKey(source.mount) === "no mount" ? "No mount" : "Mounted";
    if (mounts.indexOf(mountName) === -1) mountName = mounts[0];
    fillSelect(document.querySelector("[data-p2-mount]"), mounts, function (name) { return name; });
    document.querySelector("[data-p2-mount]").value = mountName;
    var mountColour = MOUNT_COLOURS[source.mountColour] ? source.mountColour : "White";
    document.querySelector("[data-p2-mount-colour]").value = mountColour;
    var sized = state.focus != null && state.items[state.focus] ? state.items[state.focus] : source;
    refreshSizes(sized);
  }

  function refreshColours(style) {
    fillSelect(document.querySelector("[data-p2-colour]"), STYLE_COLOURS[style] || STYLE_COLOURS.classic, function (name) { return name; });
  }

  function rememberMove() {
    moves.push({
      items: state.items.map(setShape).filter(Boolean),
      overrides: state.overrides.slice()
    });
    if (moves.length > 30) moves.shift();
  }

  function undoMove() {
    var prev = moves.pop();
    if (!prev) return;
    state.items = prev.items.map(setShape).filter(Boolean);
    state.overrides = state.items.map(function (_, index) { return !!prev.overrides[index]; });
    state.focus = null;
    state.panel = null;
    render();
  }

  function authorId() {
    var key = "planner2.author";
    try {
      var id = localStorage.getItem(key);
      if (!id) {
        id = Math.random().toString(36).slice(2, 10);
        localStorage.setItem(key, id);
      }
      return id;
    } catch (e) { return "guest"; }
  }

  function encodePlan(plan) {
    return btoa(unescape(encodeURIComponent(JSON.stringify(plan)))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  }

  function decodePlan(text) {
    try {
      var normalized = String(text || "").replace(/-/g, "+").replace(/_/g, "/");
      while (normalized.length % 4) normalized += "=";
      return JSON.parse(decodeURIComponent(escape(atob(normalized))));
    } catch (e) { return null; }
  }

  function readPlanParam(name) {
    try {
      var param = new URL(window.location.href).searchParams.get(name);
      if (!param) return null;
      var plan = decodePlan(param);
      if (!plan || !Array.isArray(plan.items) || !plan.items.length) return null;
      return plan;
    } catch (e) { return null; }
  }

  function readWall() {
    return readPlanParam("wall");
  }

  function arrangementKey() {
    return JSON.stringify({
      scene: state.scene,
      config: state.config,
      gap: state.gap,
      global: state.global,
      items: state.items.map(setShape)
    });
  }

  function currentPlan(status) {
    var share = state.share || {};
    return {
      v: 1,
      scene: state.scene,
      config: state.config,
      gap: state.gap,
      global: state.global,
      items: state.items.map(setShape).filter(Boolean),
      overrides: state.overrides.slice(),
      author: share.author || authorId(),
      status: status || share.status || "pending",
      notes: (share.notes || []).slice(-20)
    };
  }

  function wallUrl(plan) {
    var url = new URL(window.location.href);
    url.search = "";
    url.hash = "";
    url.searchParams.set("wall", encodePlan(plan));
    return url.toString();
  }

  function paintShare() {
    var share = state.share;
    var status = root.querySelector("[data-p2-share-status]");
    var notes = root.querySelector("[data-p2-share-notes]");
    var approve = root.querySelector("[data-p2-share-approve]");
    var reject = root.querySelector("[data-p2-share-reject]");
    var decide = root.querySelector("[data-p2-share-decide]");
    if (!share) {
      if (status) status.textContent = "Comments";
      if (notes) notes.innerHTML = "";
      if (approve) approve.hidden = true;
      if (reject) reject.hidden = true;
      if (decide) decide.hidden = true;
      syncCommentCue();
      return;
    }
    var labels = { pending: "Waiting for approval", approved: "Approved", rejected: "Rejected" };
    if (status) status.textContent = labels[share.status] || "Waiting for approval";
    if (notes) {
      notes.innerHTML = "";
      share.notes.forEach(function (note, index) {
        var li = document.createElement("li");
        var who = document.createElement("strong");
        var own = note.side === myCommentSide();
        who.textContent = own ? "You" : (note.side === "studio" ? "Studio" : "Client");
        var text = document.createElement("span");
        text.className = "p2-note-text";
        text.textContent = note.text || "";
        li.appendChild(who);
        li.appendChild(text);
        if (own) {
          var actions = document.createElement("span");
          actions.className = "p2-note-actions";
          actions.appendChild(noteButton("Edit", "data-p2-note-edit", index));
          actions.appendChild(noteButton("Delete", "data-p2-note-delete", index));
          li.appendChild(actions);
        }
        notes.appendChild(li);
      });
    }
    var client = !!(share.fromLink && !share.mine);
    if (approve) approve.hidden = !client;
    if (reject) reject.hidden = !client;
    if (decide) decide.hidden = !client;
    syncCommentCue();
  }

  function commentCount() {
    var notes = state.share && state.share.notes;
    if (!notes) return 0;
    return notes.filter(function (note) {
      return note && String(note.text || "").trim();
    }).length;
  }

  function syncCommentCue() {
    var button = root.querySelector("[data-p2-comments]");
    if (!button) return;
    var count = commentCount();
    button.textContent = count ? "Comments (" + count + ")" : "Comments";
    var panel = root.querySelector("[data-p2-share-panel]");
    var open = !!(panel && panel.classList.contains("is-open"));
    button.setAttribute("aria-expanded", open ? "true" : "false");
    var share = root.querySelector(".p2-bar-corner [data-p2-share]");
    if (share) share.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function placeSharePanel() {
    stage.style.width = "";
    stage.style.maxWidth = "";
    root.classList.remove("is-comments");
    var panel = root.querySelector("[data-p2-share-panel]");
    if (!panel) return;
    var header = document.getElementById("shopify-section-header");
    var top = 0;
    if (header) {
      var headerBox = header.getBoundingClientRect();
      if (headerBox.bottom > 0) top = headerBox.bottom;
    }
    var bar = root.querySelector("[data-p2-bar]");
    var bottom = 0;
    if (bar) bottom = Math.max(0, window.innerHeight - bar.getBoundingClientRect().top);
    panel.style.top = top + "px";
    panel.style.bottom = bottom + "px";
  }

  function setShareOpen(open) {
    var panel = root.querySelector("[data-p2-share-panel]");
    var button = root.querySelector("[data-p2-comments]");
    if (!panel) return;
    var wasOpen = !panel.hidden && panel.classList.contains("is-open");
    if (open && !wasOpen) {
      setWallsOpen(false);
      paintShare();
      panel.hidden = false;
      placeSharePanel();
      panel.getBoundingClientRect();
      panel.classList.add("is-open");
      panel.focus();
    } else if (!open && wasOpen) {
      panel.classList.remove("is-open");
      var settle = function (event) {
        if (event && event.target !== panel) return;
        if (event && event.propertyName && event.propertyName !== "transform") return;
        if (panel.classList.contains("is-open")) return;
        panel.hidden = true;
        panel.removeEventListener("transitionend", settle);
      };
      panel.addEventListener("transitionend", settle);
      setTimeout(function () {
        if (!panel.classList.contains("is-open")) panel.hidden = true;
      }, 400);
      if (button) button.focus();
    }
    syncCommentCue();
    placeHint();
  }

  var WALL_API = "https://fnbbzjexzdrsaxfyxsew.functions.supabase.co/planner-wall";

  function planIdFromUrl() {
    try { return new URL(window.location.href).searchParams.get("plan") || ""; }
    catch (e) { return ""; }
  }

  function planUrl(id) {
    var url = new URL(window.location.href);
    url.search = "";
    url.hash = "";
    url.searchParams.set("plan", id);
    return url.toString();
  }

  function applyServerPlan(row) {
    var plan = row && row.plan;
    if (!plan || !Array.isArray(plan.items) || !plan.items.length) return;
    var items = plan.items.map(setShape).filter(Boolean);
    if (!items.length) return;
    state.items = items;
    state.overrides = items.map(function (_, index) {
      return !!(plan.overrides && plan.overrides[index]);
    });
    if (plan.scene && sceneByHandle(plan.scene)) state.scene = plan.scene;
    var sceneRecord = sceneByHandle(state.scene) || scenes[0];
    if (plan.config && sceneRecord.configs.indexOf(plan.config) !== -1) state.config = plan.config;
    var global = finishShape(plan.global);
    if (global) state.global = global;
    state.gap = gapSize(plan.gap);
    state.share = {
      author: plan.author || row.author || "",
      status: row.status === "approved" || row.status === "rejected" ? row.status : "pending",
      notes: Array.isArray(plan.notes) ? plan.notes.slice(-20) : [],
      mine: (plan.author || "") === authorId(),
      fromLink: true,
      planId: row.id,
      base: ""
    };
    state.share.base = arrangementKey();
  }

  function loadServerPlan(done) {
    var id = planIdFromUrl();
    if (!id) { done(); return; }
    fetch(WALL_API + "?id=" + encodeURIComponent(id), { headers: { Accept: "application/json" } })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (row) { if (row) applyServerPlan(row); })
      .catch(function () {})
      .then(done);
  }

  function saveServerPlan(plan, decision) {
    return fetch(WALL_API, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        id: state.share && state.share.planId || planIdFromUrl() || "",
        plan: plan,
        decision: decision || ""
      })
    }).then(function (res) {
      return res.ok ? res.json() : null;
    }).catch(function () { return null; });
  }

  function publishShare(plan, message, decision) {
    var previousId = (state.share && state.share.planId) || planIdFromUrl();
    state.share = {
      author: plan.author,
      status: decision || plan.status,
      notes: plan.notes || [],
      mine: plan.author === authorId(),
      fromLink: true,
      planId: previousId,
      base: arrangementKey()
    };
    var hint = root.querySelector("[data-p2-share-hint]");
    if (hint) hint.textContent = "Saving…";
    paintShare();
    saveServerPlan(plan, decision).then(function (row) {
      var link = wallUrl(plan);
      if (row && row.id) {
        state.share.planId = row.id;
        state.share.status = row.status || state.share.status;
        link = planUrl(row.id);
      }
      if (window.history && history.replaceState) history.replaceState(null, "", link);
      if (hint) hint.textContent = message;
      paintShare();
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).catch(function () {
          if (hint) hint.textContent = link;
        });
      } else if (hint) hint.textContent = link;
    });
  }

  function shareWall() {
    var status = (state.share && state.share.status) || "pending";
    if (state.share && state.share.base && state.share.base !== arrangementKey()) status = "pending";
    var plan = currentPlan(status);
    plan.author = (state.share && state.share.author) || authorId();
    setShareOpen(true);
    publishShare(plan, "Link copied. Send it to your client.");
  }

  function copyShareLink() {
    var status = (state.share && state.share.status) || "pending";
    if (state.share && state.share.base && state.share.base !== arrangementKey()) status = "pending";
    var plan = currentPlan(status);
    plan.author = (state.share && state.share.author) || authorId();
    var button = root.querySelector("[data-p2-share-copy]");
    publishShare(plan, "Link copied.");
    if (!button) return;
    button.classList.add("is-copied");
    button.setAttribute("aria-label", "Link copied");
    button.title = "Link copied";
    clearTimeout(button.timer);
    button.timer = setTimeout(function () {
      button.classList.remove("is-copied");
      button.setAttribute("aria-label", "Copy link");
      button.title = "Copy link";
    }, 1600);
  }

  function myCommentSide() {
    return state.share && state.share.fromLink && !state.share.mine ? "client" : "studio";
  }

  function noteButton(label, attr, index) {
    var button = document.createElement("button");
    button.type = "button";
    button.textContent = label;
    button.setAttribute(attr, String(index));
    return button;
  }

  function editShareNote(index) {
    var share = state.share;
    var note = share && share.notes && share.notes[index];
    if (!note || note.side !== myCommentSide()) return;
    if (root.querySelector("[data-p2-note-save]")) paintShare();
    var list = root.querySelector("[data-p2-share-notes]");
    var li = list && list.children[index];
    if (!li) return;
    li.className = "is-editing";
    li.innerHTML = "";
    var box = document.createElement("textarea");
    box.rows = 2;
    box.maxLength = 400;
    box.value = note.text || "";
    var save = noteButton("Save", "data-p2-note-save", index);
    var cancel = noteButton("Cancel", "data-p2-note-cancel", index);
    li.appendChild(box);
    li.appendChild(save);
    li.appendChild(cancel);
    box.focus();
  }

  function saveShareNote(index, text) {
    text = String(text || "").trim().slice(0, 400);
    var plan = currentPlan();
    var note = plan.notes && plan.notes[index];
    if (!note || note.side !== myCommentSide()) return;
    if (!text) {
      paintShare();
      return;
    }
    plan.notes[index] = { side: note.side, text: text };
    publishShare(plan, "Comment updated. Link copied — send it back.");
  }

  function deleteShareNote(index) {
    var plan = currentPlan();
    var note = plan.notes && plan.notes[index];
    if (!note || note.side !== myCommentSide()) return;
    plan.notes.splice(index, 1);
    publishShare(plan, "Comment deleted. Link copied — send it back.");
  }

  function addShareNote(text) {
    text = String(text || "").trim().slice(0, 400);
    if (!text) return;
    var plan = currentPlan();
    plan.author = (state.share && state.share.author) || authorId();
    plan.notes = (plan.notes || []).concat([{
      side: state.share && state.share.fromLink && !state.share.mine ? "client" : "studio",
      text: text
    }]).slice(-20);
    var box = root.querySelector("[data-p2-share-note]");
    if (box) box.value = "";
    setShareOpen(true);
    publishShare(plan, "Comment added. Link copied — send it back.");
  }

  function setShareStatus(status) {
    var plan = currentPlan(status);
    plan.author = (state.share && state.share.author) || authorId();
    publishShare(plan, status === "approved" ? "Approved and saved. Link copied — send it back." : "Rejected and saved. Link copied — send it back.", status);
  }

  function loadMissingPrints(done) {
    var handles = [];
    state.items.forEach(function (item) {
      if (item && item.handle && !products[item.handle] && handles.indexOf(item.handle) === -1) handles.push(item.handle);
    });
    if (!handles.length) { done(); return; }
    Promise.all(handles.map(function (handle) {
      return fetch("/products/" + encodeURIComponent(handle) + ".js", {
        credentials: "same-origin",
        headers: { Accept: "application/json" }
      }).then(function (res) {
        if (!res.ok) throw new Error("missing");
        return res.json();
      }).then(catalogueFromAjax).then(function (product) {
        if (!product) return;
        products[product.handle] = product;
        if (!catalogue.some(function (entry) { return entry.handle === product.handle; })) catalogue.push(product);
      }).catch(function () {});
    })).then(done);
  }

  function readHold() {
    try {
      var hold = JSON.parse(localStorage.getItem(HOLD_KEY) || "null");
      if (!hold || !hold.selection || !Array.isArray(hold.selection.items) || !hold.selection.items.length) return null;
      if (typeof hold.at !== "number" || Date.now() - hold.at > 6 * 60 * 60 * 1000) {
        localStorage.removeItem(HOLD_KEY);
        return null;
      }
      return hold;
    } catch (e) { return null; }
  }

  function loadState() {
    var stored = null;
    try { stored = JSON.parse(sessionStorage.getItem(STORAGE) || "null"); } catch (e) { stored = null; }
    loginHold = readHold();
    if (loginHold && !loginHold.selection.items.map(setShape).filter(Boolean).length) loginHold = null;
    var shared = readWall();
    var setLink = shared ? null : readPlanParam("set");
    var source = (loginHold && loginHold.selection) || shared || setLink || stored;
    var items = source && Array.isArray(source.items) ? source.items.map(setShape).filter(Boolean) : seed.map(setShape).filter(Boolean);
    if (!items.length) items = seed.map(setShape).filter(Boolean);
    var overrides = items.map(function (_, index) {
      return !!(source && source.overrides && source.overrides[index]);
    });
    var scene = source && source.scene && sceneByHandle(source.scene) ? source.scene : scenes[0].handle;
    var sceneRecord = sceneByHandle(scene) || scenes[0];
    var config = source && source.config && sceneRecord.configs.indexOf(source.config) !== -1 ? source.config : sceneRecord.config;
    var global = finishShape(source && source.global) || finishShape({
      frametype: "Classic", frame: "Oak", mount: "Mounted", mountColour: "White"
    });
    var share = null;
    if (shared && !loginHold) {
      share = {
        author: shared.author || "",
        status: shared.status === "approved" || shared.status === "rejected" ? shared.status : "pending",
        notes: Array.isArray(shared.notes) ? shared.notes.slice(-20) : [],
        mine: (shared.author || "") === authorId(),
        fromLink: true
      };
    }
    var keepSet = source === setLink || !!(source === stored && stored && stored.keepSet);
    return { items: items, overrides: overrides, scene: scene, config: config, global: global, gap: gapSize(source && source.gap), focus: null, editing: false, share: share, keepSet: keepSet };
  }

  function persist() {
    try {
      sessionStorage.setItem(STORAGE, JSON.stringify({
        items: state.items.map(setShape),
        overrides: state.overrides,
        scene: state.scene,
        config: state.config,
        global: state.global,
        gap: state.gap,
        keepSet: !!state.keepSet
      }));
    } catch (e) {}
  }

  function finishShape(item) {
    var style = styleKey(item && item.frametype) || "classic";
    var mount = mountKey(item && item.mount) || "mounted";
    if (mount === "print only") return null;
    var frame = (item && item.frame) || STYLE_DEFAULT[style];
    if (STYLE_COLOURS[style].indexOf(frame) === -1) frame = STYLE_DEFAULT[style];
    var mountColour = item && MOUNT_COLOURS[item.mountColour] ? item.mountColour : "White";
    var writtenMount = mount === "no mount" ? "No mount" : mount === "mounted" ? "Mounted" : String(item.mount).trim();
    return { frametype: labelStyle(style), frame: frame, mount: writtenMount, mountColour: mountColour };
  }

  function setShape(item) {
    if (!item || !item.handle) return null;
    var finish = finishShape(item);
    if (!finish || !styleKey(item.frametype)) return null;
    return {
      handle: item.handle,
      size: item.size || "Medium",
      frametype: finish.frametype,
      frame: finish.frame,
      mount: finish.mount,
      mountColour: finish.mountColour
    };
  }

  function currentSlots() {
    var grid = parseConfig(state.config);
    return grid ? grid.rows * grid.cols : 0;
  }

  function ensureFullGrid(slots) {
    if (state.keepSet) return;
    if (!(slots > state.items.length)) return;
    var finish = state.global;
    var candidates = [];
    catalogue.forEach(function (product) {
      var size = sizeLabelFor(product, finish);
      if (!size) return;
      var item = setShape({
        handle: product.handle,
        size: size,
        frametype: finish.frametype,
        frame: finish.frame,
        mount: finish.mount,
        mountColour: finish.mountColour
      });
      if (!item || !resolve(item)) return;
      candidates.push(item);
    });
    if (!candidates.length) return;
    var used = {};
    state.items.forEach(function (item) { used[item.handle] = true; });
    var fresh = shuffle(candidates.filter(function (item) { return !used[item.handle]; }));
    var i = 0;
    while (state.items.length < slots && i < fresh.length) {
      state.items.push(setShape(fresh[i]));
      state.overrides.push(false);
      i++;
    }
    var copies = shuffle(candidates.slice());
    var n = 0;
    while (state.items.length < slots && copies.length && n < slots * copies.length) {
      state.items.push(setShape(copies[n % copies.length]));
      state.overrides.push(false);
      n++;
    }
  }

  function sizeLabelFor(product, finish) {
    var wantStyle = styleKey(finish.frametype);
    var wantMount = mountKey(finish.mount);
    if (!wantStyle || (wantMount !== "mounted" && wantMount !== "no mount")) return "";
    var found = "";
    SIZE_CHOICES.forEach(function (size) {
      if (found) return;
      (product.variants || []).some(function (variant) {
        if (tierOf(variant.size) !== size.tier) return false;
        if (styleKey(variant.frametype) !== wantStyle) return false;
        if (mountKey(variant.mount) !== wantMount) return false;
        if (!printCm(variant.size)) return false;
        found = size.label;
        return true;
      });
    });
    return found;
  }

  function shuffle(list) {
    var copy = list.slice();
    for (var i = copy.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = copy[i];
      copy[i] = copy[j];
      copy[j] = tmp;
    }
    return copy;
  }

  function sceneByHandle(handle) {
    var found = null;
    scenes.forEach(function (scene) {
      scene.configs = String(scene.configs || "").split(",").map(function (part) { return part.trim(); }).filter(Boolean);
      if (!scene.config) scene.config = scene.configs[0] || "3";
      if (scene.handle === handle) found = scene;
    });
    return found;
  }

  function gapSize(value) {
    var n = parseFloat(value);
    if (n === GAP_CM * 2 || n === GAP_CM * 4 || n === GAP_CM * 8) return n;
    return GAP_CM;
  }

  function rowWidth(row, gap) {
    var width = 0;
    row.forEach(function (print, index) {
      width += print.outerW;
      if (index) width += gap;
    });
    return width;
  }

  function rowHeight(row) {
    var height = 0;
    row.forEach(function (print) { if (print.outerH > height) height = print.outerH; });
    return height;
  }

  function tierOf(label) {
    return String(label || "").split("(")[0].trim().toLowerCase().replace(/[^a-z0-9]/g, "");
  }

  function styleKey(value) {
    var text = String(value || "").trim().toLowerCase();
    if (text === "deep classic") return "deep classic";
    if (text === "swoop") return "swoop";
    if (text === "venice") return "venice";
    if (text === "classic") return "classic";
    return "";
  }

  function labelStyle(style) {
    if (style === "deep classic") return "Deep Classic";
    if (style === "swoop") return "Swoop";
    if (style === "venice") return "Venice";
    return "Classic";
  }

  function mountKey(value) {
    var text = String(value || "").trim().toLowerCase();
    if (text === "print only") return "print only";
    if (text === "double mount") return "double mount";
    if (text === "no mount") return "no mount";
    if (text === "mounted") return "mounted";
    return "";
  }

  function colourKey(value) {
    var text = String(value || "").trim().toLowerCase();
    if (text === "antique gold") return "antique-gold";
    if (text === "antique silver") return "antique-silver";
    if (text === "black and pewter") return "black-pewter";
    if (text === "terracotta and silver") return "terracotta-silver";
    if (text === "white and silver") return "white-silver";
    return text.split(" ")[0];
  }

  function printCm(label) {
    var match = String(label || "").match(/(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)/i);
    if (!match) return null;
    var w = parseFloat(match[1]);
    var h = parseFloat(match[2]);
    if (!(w > 0) || !(h > 0)) return null;
    return { w: w, h: h };
  }

  function parseConfig(value) {
    var text = String(value || "").trim().toLowerCase();
    var grid = text.match(/^(\d+)\s*x\s*(\d+)$/);
    if (grid) return { rows: parseInt(grid[1], 10), cols: parseInt(grid[2], 10) };
    var single = text.match(/^(\d+)$/);
    if (single) return { rows: 1, cols: parseInt(single[1], 10) };
    return null;
  }

  function parseRect(value) {
    var parts = String(value || "").split(",").map(function (part) { return parseFloat(part); });
    if (parts.length !== 4 || parts.some(function (n) { return !isFinite(n); })) return null;
    if (!(parts[2] > 0) || !(parts[3] > 0)) return null;
    return { x: parts[0], y: parts[1], w: parts[2], h: parts[3] };
  }

  function fillSelect(select, values, label) {
    var current = select.value;
    select.innerHTML = "";
    values.forEach(function (value) {
      var option = document.createElement("option");
      option.value = value;
      option.textContent = label(value);
      select.appendChild(option);
    });
    if (values.indexOf(current) !== -1) select.value = current;
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || "£{{amount}}";
    var amount = (cents / 100).toFixed(2);
    return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }

  function withWidth(url, width) {
    var next = new URL(url, window.location.href);
    next.searchParams.set("width", String(width));
    return next.toString();
  }

  function decode(img) {
    if (!img || !img.getAttribute("src") && !img.src) return Promise.resolve();
    if (img.decode) return img.decode().catch(function () {});
    return Promise.resolve();
  }

  function parseJson(node) {
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function saveSceneImage() {
    var button = root.querySelector("[data-p2-save]");
    if (!button || button.disabled || !placed || !activeScene) return;
    var label = "Save image";
    button.disabled = true;
    button.textContent = "Saving…";
    exportSceneJpeg().then(function (blob) {
      downloadBlob(blob, sceneFileName());
      button.textContent = "Saved";
    }).catch(function () {
      button.textContent = "Couldn't save";
    }).then(function () {
      setTimeout(function () {
        button.textContent = label;
        button.disabled = false;
      }, 1600);
    });
  }

  function sceneFileName() {
    var name = (activeScene && activeScene.name) || "wall";
    var slug = String(name).toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
    return "theartfolio-" + (slug || "wall") + ".jpg";
  }

  function downloadBlob(blob, name) {
    var url = URL.createObjectURL(blob);
    var link = document.createElement("a");
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    setTimeout(function () { URL.revokeObjectURL(url); }, 1500);
  }

  function exportSceneJpeg() {
    var cssW = stage.clientWidth;
    var cssH = stage.clientHeight;
    if (!(cssW > 0) || !(cssH > 0)) return Promise.reject(new Error("stage"));
    var nativeW = parseFloat(activeScene.imageWidth) || cssW;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var targetW = Math.round(Math.min(Math.max(cssW * dpr, cssW), nativeW));
    var scale = targetW / cssW;
    var width = Math.max(1, Math.round(cssW * scale));
    var height = Math.max(1, Math.round(cssH * scale));
    var origin = stage.getBoundingClientRect();
    var canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    var ctx = canvas.getContext("2d");
    var cache = {};
    var loaded = {};

    function boxOf(el) {
      var b = el.getBoundingClientRect();
      return {
        x: (b.left - origin.left) * scale,
        y: (b.top - origin.top) * scale,
        w: b.width * scale,
        h: b.height * scale
      };
    }

    function loadImage(url) {
      if (!url) return Promise.resolve(null);
      if (cache[url]) return cache[url];
      cache[url] = new Promise(function (resolve) {
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = function () { loaded[url] = img; resolve(img); };
        img.onerror = function () { resolve(null); };
        img.src = url;
      });
      return cache[url];
    }

    function cssImageUrl(value) {
      var match = /url\((['"]?)(.+?)\1\)/.exec(value || "");
      return match ? match[2] : "";
    }

    function frameMetrics(frame) {
      var s = Math.min(2.2, Math.max(0.8, frame.clientWidth / 280));
      var depth = 1;
      if (frame.hasAttribute("data-deep-classic")) depth = 1.45;
      else if (frame.hasAttribute("data-swoop")) depth = 1.15;
      else if (frame.hasAttribute("data-venice")) depth = 1.25;
      var colour = frame.getAttribute("data-classic") || frame.getAttribute("data-deep-classic") || frame.getAttribute("data-swoop") || frame.getAttribute("data-venice") || "";
      var sep = 1;
      if (["white", "silver", "antique-silver", "natural", "white-silver"].indexOf(colour) !== -1) sep = 1.2;
      if (["black", "black-pewter"].indexOf(colour) !== -1) sep = 0.85;
      var lx = parseFloat(getComputedStyle(stage).getPropertyValue("--fv-lx"));
      if (!lx) lx = 1;
      return { s: s, depth: depth, sep: sep, lx: lx };
    }

    function fillFrame(box, frame) {
      var bg = getComputedStyle(frame).backgroundImage || "";
      var colors = bg.match(/rgba?\([^)]+\)/g);
      if (colors && colors.length >= 2) {
        var gradient = ctx.createLinearGradient(box.x, box.y, box.x + box.w, box.y + box.h);
        gradient.addColorStop(0, colors[0]);
        gradient.addColorStop(1, colors[colors.length - 1]);
        ctx.fillStyle = gradient;
      } else {
        ctx.fillStyle = "#c4a27a";
      }
      ctx.fillRect(box.x, box.y, box.w, box.h);
    }

    function dropShadow(box, metrics) {
      var layers = [
        [1, 2, 3, 0, 0.50],
        [2, 5, 7, 0, 0.34],
        [3, 8, 12, -2, 0.16]
      ];
      layers.forEach(function (layer) {
        var spread = layer[3] * metrics.s * metrics.depth * scale;
        ctx.save();
        ctx.shadowOffsetX = layer[0] * metrics.lx * metrics.s * metrics.depth * scale;
        ctx.shadowOffsetY = layer[1] * metrics.s * metrics.depth * scale;
        ctx.shadowBlur = layer[2] * metrics.s * metrics.depth * scale;
        ctx.shadowColor = "rgba(20,16,12," + (layer[4] * metrics.sep) + ")";
        ctx.fillStyle = "#000";
        ctx.fillRect(box.x - spread, box.y - spread, box.w + spread * 2, box.h + spread * 2);
        ctx.restore();
      });
    }

    function insetShadow(box, offsetX, offsetY, blur, color) {
      ctx.save();
      ctx.beginPath();
      ctx.rect(box.x, box.y, box.w, box.h);
      ctx.clip();
      ctx.shadowColor = color;
      ctx.shadowBlur = Math.max(0, blur);
      ctx.shadowOffsetX = offsetX;
      ctx.shadowOffsetY = offsetY;
      ctx.fillStyle = "#000";
      ctx.beginPath();
      ctx.rect(box.x - box.w, box.y - box.h, box.w * 3, box.h);
      ctx.rect(box.x - box.w, box.y + box.h, box.w * 3, box.h);
      ctx.rect(box.x - box.w, box.y, box.w, box.h);
      ctx.rect(box.x + box.w, box.y, box.w, box.h);
      ctx.fill();
      ctx.restore();
    }

    function drawCover(img, box) {
      if (!img) return;
      var ir = img.naturalWidth / (img.naturalHeight || 1);
      var r = box.w / (box.h || 1);
      var sx = 0;
      var sy = 0;
      var sw = img.naturalWidth;
      var sh = img.naturalHeight;
      if (ir > r) {
        sw = sh * r;
        sx = (img.naturalWidth - sw) / 2;
      } else {
        sh = sw / r;
        sy = (img.naturalHeight - sh) / 2;
      }
      ctx.drawImage(img, sx, sy, sw, sh, box.x, box.y, box.w, box.h);
    }

    function railSide(rail) {
      if (rail.classList.contains("p2-rail--r")) return "r";
      if (rail.classList.contains("p2-rail--b")) return "b";
      if (rail.classList.contains("p2-rail--l")) return "l";
      return "t";
    }

    function clipRail(box, side, thickness) {
      var x = box.x;
      var y = box.y;
      var w = box.w;
      var h = box.h;
      var t = Math.min(thickness, w, h);
      ctx.beginPath();
      if (side === "b") {
        ctx.moveTo(x + t, y);
        ctx.lineTo(x + w - t, y);
        ctx.lineTo(x + w, y + h);
        ctx.lineTo(x, y + h);
      } else if (side === "l") {
        ctx.moveTo(x, y);
        ctx.lineTo(x + w, y + t);
        ctx.lineTo(x + w, y + h - t);
        ctx.lineTo(x, y + h);
      } else if (side === "r") {
        ctx.moveTo(x, y + t);
        ctx.lineTo(x + w, y);
        ctx.lineTo(x + w, y + h);
        ctx.lineTo(x, y + h - t);
      } else {
        ctx.moveTo(x, y);
        ctx.lineTo(x + w, y);
        ctx.lineTo(x + w - t, y + h);
        ctx.lineTo(x + t, y + h);
      }
      ctx.closePath();
      ctx.clip();
    }

    var prints = Array.prototype.slice.call(hang.querySelectorAll(".p2-print"));
    var jobs = [loadImage(withWidth(activeScene.image, width))];
    prints.forEach(function (print) {
      var item = null;
      placed.items.forEach(function (entry) {
        if (String(entry.selectionIndex) === print.dataset.index) item = entry;
      });
      var piece = print.querySelector(".p2-piece");
      var pieceBox = piece ? boxOf(piece) : null;
      if (item && item.image && pieceBox) jobs.push(loadImage(withWidth(item.image, Math.max(1, Math.ceil(pieceBox.w)))));
      print.querySelectorAll(".p2-rail").forEach(function (rail) {
        var url = cssImageUrl(getComputedStyle(rail).backgroundImage);
        if (url) jobs.push(loadImage(url));
      });
    });

    return Promise.all(jobs).then(function (images) {
      var scenePhoto = images[0];
      ctx.fillStyle = "#e4dfd6";
      ctx.fillRect(0, 0, width, height);
      if (scenePhoto) ctx.drawImage(scenePhoto, 0, 0, width, height);
      prints.forEach(function (print) {
        var frame = print.querySelector(".p2-frame");
        var mount = print.querySelector(".p2-mount");
        var piece = print.querySelector(".p2-piece");
        if (!frame || !mount || !piece) return;
        var frameBox = boxOf(frame);
        var mountBox = boxOf(mount);
        var pieceBox = boxOf(piece);
        var metrics = frameMetrics(frame);
        var item = null;
        placed.items.forEach(function (entry) {
          if (String(entry.selectionIndex) === print.dataset.index) item = entry;
        });
        dropShadow(frameBox, metrics);
        fillFrame(frameBox, frame);
        ctx.fillStyle = getComputedStyle(mount).backgroundColor || "#ffffff";
        ctx.fillRect(mountBox.x, mountBox.y, mountBox.w, mountBox.h);
        ctx.save();
        ctx.beginPath();
        ctx.rect(pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h);
        ctx.clip();
        ctx.fillStyle = "#f4f1ea";
        ctx.fillRect(pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h);
        if (item && item.image) {
          drawCover(loaded[withWidth(item.image, Math.max(1, Math.ceil(pieceBox.w)))], pieceBox);
        }
        ctx.restore();
        if (!mount.classList.contains("is-off")) {
          ctx.save();
          ctx.strokeStyle = "rgba(255,255,255,.78)";
          ctx.lineWidth = 2 * scale;
          ctx.strokeRect(pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h);
          ctx.strokeStyle = "rgba(0,0,0,.18)";
          ctx.lineWidth = Math.max(1, scale);
          ctx.strokeRect(pieceBox.x, pieceBox.y, pieceBox.w, pieceBox.h);
          ctx.restore();
          var ps = metrics.s * scale;
          insetShadow(pieceBox, 2 * ps, 0, 4 * ps, "rgba(0,0,0,.22)");
          insetShadow(pieceBox, -2 * ps, 0, 4 * ps, "rgba(0,0,0,.26)");
          insetShadow(pieceBox, 0, 3 * ps, 5 * ps, "rgba(0,0,0,.40)");
          insetShadow(pieceBox, 0, -2 * ps, 4 * ps, "rgba(0,0,0,.16)");
        }
        var open = metrics.s * metrics.depth * scale;
        insetShadow(mountBox, 2 * metrics.lx * open, 3 * open, 7 * open, "rgba(0,0,0,.34)");
        ctx.save();
        ctx.strokeStyle = "rgba(0,0,0,.16)";
        ctx.lineWidth = Math.max(1, scale);
        ctx.strokeRect(mountBox.x, mountBox.y, mountBox.w, mountBox.h);
        ctx.restore();
        var thickness = parseFloat(getComputedStyle(frame).paddingTop) * scale || frameBox.w * 0.06;
        print.querySelectorAll(".p2-rail").forEach(function (rail) {
          var url = cssImageUrl(getComputedStyle(rail).backgroundImage);
          var photo = url ? loaded[url] : null;
          var box = boxOf(rail);
          ctx.save();
          clipRail(box, railSide(rail), thickness);
          var filter = getComputedStyle(rail).filter;
          if (filter && filter !== "none") ctx.filter = filter;
          if (photo) ctx.drawImage(photo, box.x, box.y, box.w, box.h);
          ctx.restore();
        });
      });
      return new Promise(function (resolve, reject) {
        canvas.toBlob(function (blob) {
          if (blob) resolve(blob);
          else reject(new Error("blob"));
        }, "image/jpeg", 0.92);
      });
    });
  }

  // Account walls. The working wall stays in sessionStorage via persist().
  // A guest Save wall asks them to log in, and planner2.hold brings that
  // arrangement back if the login round-trip opens a new tab. A customer id is never sent.
  var WALLS_API = "/apps/artfolio/walls";
  var accountReady = false;
  var ownerWalls = [];
  var ownerDeleted = [];
  var wallQuery = "";
  var savedStamp = "";

  function wallsFetch(query, options) {
    var opts = options || {};
    opts.credentials = "same-origin";
    opts.headers = opts.headers || {};
    opts.headers.Accept = "application/json";
    return fetch(WALLS_API + (query || ""), opts).then(function (res) {
      return res.json().catch(function () { return null; }).then(function (body) {
        return { ok: res.ok, status: res.status, body: body };
      });
    });
  }

  function wallStatus(message) {
    var node = root.querySelector("[data-p2-walls-status]");
    if (node) {
      node.textContent = message || "";
      node.hidden = !message;
    }
    var panel = root.querySelector("[data-p2-walls]");
    var save = root.querySelector("[data-p2-walls-save]");
    if (!save || (panel && !panel.hidden)) return;
    save.textContent = message;
    save.title = message;
    clearTimeout(wallStatus.timer);
    wallStatus.timer = setTimeout(paintSaveLabel, 2000);
  }

  function wallError(body) {
    var code = body && body.error;
    if (code === "wall_limit") return "You already have 200 saved walls. Delete one to save another.";
    if (code === "not_found") return "That wall is not on this account.";
    return "The wall could not be saved. Try again.";
  }

  function wallDocument() {
    var items = [];
    var overrides = [];
    state.items.forEach(function (item, index) {
      var shaped = setShape(item);
      if (!shaped) return;
      items.push(shaped);
      overrides.push(!!state.overrides[index]);
    });
    return {
      scene: state.scene,
      config: state.config,
      gap: state.gap,
      global: state.global,
      items: items,
      overrides: overrides
    };
  }

  function placeWallsPanel() {
    var panel = root.querySelector("[data-p2-walls]");
    if (!panel) return;
    var header = document.getElementById("shopify-section-header");
    var top = 0;
    if (header) {
      var headerBox = header.getBoundingClientRect();
      if (headerBox.bottom > 0) top = headerBox.bottom;
    }
    var bar = root.querySelector("[data-p2-bar]");
    var bottom = 0;
    if (bar) bottom = Math.max(0, window.innerHeight - bar.getBoundingClientRect().top);
    panel.style.top = top + "px";
    panel.style.bottom = bottom + "px";
  }

  function setWallsOpen(open) {
    var panel = root.querySelector("[data-p2-walls]");
    var button = root.querySelector("[data-p2-walls-open]");
    if (!panel) return;
    var wasOpen = !panel.hidden && panel.classList.contains("is-open");
    if (open && !wasOpen) {
      setShareOpen(false);
      panel.hidden = false;
      placeWallsPanel();
      panel.getBoundingClientRect();
      panel.classList.add("is-open");
      panel.focus();
      refreshOwnerWalls();
    } else if (!open && wasOpen) {
      panel.classList.remove("is-open");
      var settle = function (event) {
        if (event && event.target !== panel) return;
        if (event && event.propertyName && event.propertyName !== "transform") return;
        if (panel.classList.contains("is-open")) return;
        panel.hidden = true;
        panel.removeEventListener("transitionend", settle);
      };
      panel.addEventListener("transitionend", settle);
      setTimeout(function () {
        if (!panel.classList.contains("is-open")) panel.hidden = true;
      }, 400);
      if (button && button.offsetParent) button.focus();
    }
    if (button && !button.hidden) button.setAttribute("aria-expanded", panel.classList.contains("is-open") ? "true" : "false");
    placeHint();
    requestAnimationFrame(placeHint);
  }

  function wallNameValue() {
    var nameInput = root.querySelector("[data-p2-walls-name]");
    var name = nameInput && String(nameInput.value || "").trim();
    return name || "Untitled wall";
  }

  function wallStamp() {
    return JSON.stringify({ name: wallNameValue(), doc: wallDocument() });
  }

  function markWallSaved() {
    savedStamp = wallStamp();
    paintSaveLabel();
  }

  function openedWall() {
    if (!state.wallId) return null;
    var match = ownerWalls.filter(function (row) { return row.id === state.wallId; });
    return match[0] || null;
  }

  function signedIn() {
    return accountReady || customerOnPage();
  }

  function savedWallLabel() {
    if (!state.wallId) return "";
    var current = openedWall();
    if (current && current.name) return current.name;
    var nameInput = root.querySelector("[data-p2-walls-name]");
    return nameInput ? String(nameInput.value || "").trim() : "";
  }

  function paintBarWall() {
    var node = root.querySelector("[data-p2-bar-wall]");
    if (!node) return;
    var name = savedWallLabel();
    node.textContent = name;
    node.hidden = !name;
    node.title = name;
  }

  function paintSaveLabel() {
    var buttons = root.querySelectorAll("[data-p2-walls-save]");
    if (!buttons.length) {
      paintBarWall();
      return;
    }
    if (!signedIn()) {
      buttons.forEach(function (button) {
        if (!button.closest(".p2-bar-corner")) return;
        button.hidden = false;
        button.textContent = "Save Wall";
        button.title = "Log in to save this wall";
        button.classList.remove("is-overwrite");
      });
      paintBarWall();
      return;
    }
    var current = openedWall();
    var existing = !!state.wallId;
    buttons.forEach(function (button) {
      var inBar = !!button.closest(".p2-bar-corner");
      var label = existing ? (inBar ? "Update Wall" : "Update") : (inBar ? "Save Wall" : "Save");
      var title = existing ? ("Update " + ((current && current.name) || "this wall")) : (inBar ? "Save Wall" : "Save");
      button.textContent = label;
      button.title = title;
      button.classList.toggle("is-overwrite", existing);
    });
    paintBarWall();
  }

  function wallMatches(wall) {
    var query = wallQuery.trim().toLowerCase();
    if (!query) return true;
    return String([wall.name, wall.project].concat(wall.tags || []).join(" ")).toLowerCase().indexOf(query) !== -1;
  }

  function wallIconButton(label, attr, id, svg) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "p2-walls-icon";
    button.setAttribute("aria-label", label);
    button.title = label;
    button.setAttribute(attr, id);
    button.innerHTML = svg;
    return button;
  }

  function wallIconRename() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 20h4L18.5 9.5a2.1 2.1 0 0 0-3-3L5 17v3z" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/><path d="M13.2 6.8l3 3" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  }

  function wallIconDuplicate() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="8" y="8" width="12" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="1.7"/><path d="M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  }

  function wallIconLink() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M10 13a5 5 0 0 0 7.1.1l1.8-1.8a5 5 0 0 0-7.1-7.1L10.5 5.5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/><path d="M14 11a5 5 0 0 0-7.1-.1L5.1 12.7a5 5 0 0 0 7.1 7.1l1.3-1.3" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  }

  function wallIconBin() {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function copyOwnerWallLink(id) {
    if (!id) return;
    wallStatus("Copying link…");
    wallsFetch("?id=" + encodeURIComponent(id)).then(function (res) {
      var wall = res.body && res.body.wall;
      if (!res.ok || !wall) {
        wallStatus(wallError(res.body));
        return;
      }
      var plan = {
        v: 1,
        scene: wall.scene,
        config: wall.config,
        gap: wall.gap,
        global: wall.global,
        items: wall.items || [],
        overrides: wall.overrides || [],
        author: authorId(),
        status: "pending",
        notes: []
      };
      var link = wallUrl(plan);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(link).then(function () {
          wallStatus("Link copied.");
          setTimeout(function () {
            var node = root.querySelector("[data-p2-walls-status]");
            if (node && node.textContent === "Link copied.") wallStatus("");
          }, 2000);
        }).catch(function () {
          wallStatus(link);
        });
        return;
      }
      wallStatus(link);
    }).catch(function () {
      wallStatus("The link could not be copied.");
    });
  }

  function paintOwnerWalls() {
    var list = root.querySelector("[data-p2-walls-list]");
    if (!list) return;
    if (ownerWalls.length <= 10 && wallQuery) {
      wallQuery = "";
      var find = root.querySelector("[data-p2-walls-find]");
      if (find) find.value = "";
    }
    var live = ownerWalls.filter(wallMatches);
    list.innerHTML = "";
    var empty = root.querySelector("[data-p2-walls-empty]");
    if (empty) {
      empty.hidden = live.length > 0;
      empty.textContent = wallQuery.trim() ? "No walls match." : "No saved walls yet.";
    }
    var count = root.querySelector("[data-p2-walls-count]");
    if (count) {
      if (!ownerWalls.length) count.textContent = "";
      else if (wallQuery.trim()) count.textContent = live.length + " of " + ownerWalls.length;
      else count.textContent = ownerWalls.length + " saved";
    }
    paintWallFilter();
    live.forEach(function (wall) {
      var li = document.createElement("li");
      if (wall.id === state.wallId) li.className = "is-open";
      var row = document.createElement("div");
      row.className = "p2-walls-row";
      var open = document.createElement("button");
      open.type = "button";
      open.textContent = wall.name;
      open.setAttribute("data-p2-walls-pick", wall.id);
      var icons = document.createElement("span");
      icons.className = "p2-walls-icons";
      icons.appendChild(wallIconButton("Rename", "data-p2-walls-rename", wall.id, wallIconRename()));
      icons.appendChild(wallIconButton("Duplicate", "data-p2-walls-copy", wall.id, wallIconDuplicate()));
      icons.appendChild(wallIconButton("Copy share link", "data-p2-walls-link", wall.id, wallIconLink()));
      icons.appendChild(wallIconButton("Delete", "data-p2-walls-remove", wall.id, wallIconBin()));
      row.appendChild(open);
      row.appendChild(icons);
      li.appendChild(row);
      var meta = document.createElement("p");
      meta.className = "p2-walls-meta";
      if (wall.project) {
        var project = document.createElement("span");
        project.textContent = wall.project;
        meta.appendChild(project);
      }
      (wall.tags || []).forEach(function (tag) {
        var chip = document.createElement("span");
        chip.textContent = tag;
        meta.appendChild(chip);
      });
      if (wall.approval === "approved" || wall.approval === "rejected" || wall.approval === "pending") {
        var mark = document.createElement("span");
        mark.className = wall.approval === "approved" ? "is-approved" : (wall.approval === "rejected" ? "is-rejected" : "");
        mark.textContent = wall.approval === "approved" ? "Approved" : (wall.approval === "rejected" ? "Rejected" : "Waiting");
        meta.appendChild(mark);
      }
      if (meta.childNodes.length) li.appendChild(meta);
      list.appendChild(li);
    });
    var deletedList = root.querySelector("[data-p2-walls-deleted]");
    var deletedLabel = root.querySelector("[data-p2-walls-deleted-label]");
    if (!deletedList) {
      paintSaveLabel();
      return;
    }
    deletedList.innerHTML = "";
    var removed = ownerDeleted.filter(wallMatches);
    var showDeleted = removed.length > 0;
    deletedList.hidden = !showDeleted;
    if (deletedLabel) deletedLabel.hidden = !showDeleted;
    removed.forEach(function (wall) {
      var li = document.createElement("li");
      var name = document.createElement("span");
      name.textContent = wall.name;
      var restore = document.createElement("button");
      restore.type = "button";
      restore.textContent = "Restore";
      restore.setAttribute("data-p2-walls-restore", wall.id);
      li.appendChild(name);
      li.appendChild(restore);
      deletedList.appendChild(li);
    });
    paintSaveLabel();
  }

  function rememberOwnerWall(wall) {
    if (!wall || !wall.id) return;
    var next = ownerWalls.filter(function (row) { return row.id !== wall.id; });
    next.unshift({
      id: wall.id,
      name: wall.name,
      scene: wall.scene,
      config: wall.config,
      project: wall.project || "",
      tags: Array.isArray(wall.tags) ? wall.tags : [],
      approval: wall.approval || "",
      updatedAt: wall.updatedAt
    });
    ownerWalls = next;
    paintOwnerWalls();
  }

  function refreshOwnerWalls() {
    return wallsFetch("").then(function (res) {
      var body = res.body || {};
      if (!body.hasCustomer) return;
      ownerWalls = Array.isArray(body.walls) ? body.walls : [];
      ownerDeleted = Array.isArray(body.deleted) ? body.deleted : [];
      paintOwnerWalls();
    }).catch(function () {});
  }

  function customerOnPage() {
    var theme = window.theme || {};
    return theme.loggedIn === true || !!theme.customerId;
  }

  function revealSave() {
    var open = root.querySelector("[data-p2-walls-open]");
    if (open) open.hidden = false;
  }

  function selectionSnapshot() {
    return {
      items: state.items.map(setShape).filter(Boolean),
      overrides: state.overrides.slice(),
      scene: state.scene,
      config: state.config,
      global: state.global,
      gap: state.gap
    };
  }

  function closeLoginAsk() {
    var dialog = document.querySelector("[data-p2-login]");
    if (!dialog || dialog.hidden) return;
    dialog.hidden = true;
    var save = root.querySelector(".p2-bar-corner [data-p2-walls-save]");
    if (save) save.focus();
  }

  function askLoginToSave() {
    if (!selectionSnapshot().items.length) {
      wallStatus("Add a print before saving.");
      return;
    }
    persist();
    var dialog = document.querySelector("[data-p2-login]");
    if (!dialog) {
      goToLogin();
      return;
    }
    if (dialog.parentNode !== document.body) document.body.appendChild(dialog);
    if (!dialog.dataset.bound) {
      dialog.dataset.bound = "1";
      dialog.addEventListener("click", function (event) {
        if (event.target.closest("[data-p2-login-go]")) {
          goToLogin();
          return;
        }
        if (event.target.closest("[data-p2-login-cancel]") || event.target === dialog) closeLoginAsk();
      });
    }
    dialog.hidden = false;
    var go = dialog.querySelector("[data-p2-login-go]");
    if (go) go.focus();
  }

  function goToLogin() {
    persist();
    try {
      localStorage.setItem(HOLD_KEY, JSON.stringify({
        at: Date.now(),
        selection: selectionSnapshot()
      }));
    } catch (e) {}
    var back = window.location.pathname + window.location.search;
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete("wall");
      back = url.pathname + url.search;
    } catch (e) {}
    window.location.assign("/customer_authentication/login?return_to=" + encodeURIComponent(back));
  }

  function resumeAfterLogin() {
    if (!loginHold || !signedIn()) return;
    loginHold = null;
    revealSave();
    var name = root.querySelector("[data-p2-walls-name]");
    if (name && !name.value) name.value = "Untitled wall";
    setWallsOpen(true);
    wallStatus("You're signed in. Save this wall.");
    if (name) name.focus();
  }

  function bootWalls() {
    paintSaveLabel();
    if (customerOnPage()) revealSave();
    resumeAfterLogin();
    var nameField = root.querySelector("[data-p2-walls-name]");
    if (nameField && !nameField.dataset.bound) {
      nameField.dataset.bound = "1";
      nameField.addEventListener("input", paintSaveLabel);
    }
    var find = root.querySelector("[data-p2-walls-find]");
    if (find && !find.dataset.bound) {
      find.dataset.bound = "1";
      find.addEventListener("input", function () {
        wallQuery = find.value;
        paintOwnerWalls();
      });
    }
    wallsFetch("").then(function (res) {
      var body = res.body || {};
      if (!body.hasCustomer) {
        loginHold = null;
        paintSaveLabel();
        return;
      }
      accountReady = true;
      revealSave();
      resumeAfterLogin();
      var name = root.querySelector("[data-p2-walls-name]");
      if (name && !name.value) name.value = "Untitled wall";
      ownerWalls = Array.isArray(body.walls) ? body.walls : [];
      ownerDeleted = Array.isArray(body.deleted) ? body.deleted : [];
      paintOwnerWalls();
    }).catch(function () {});
  }

  function applyOwnerWall(wall) {
    var items = (wall.items || []).map(setShape).filter(Boolean);
    if (!items.length) return false;
    state.items = items;
    state.overrides = items.map(function (_, index) { return !!(wall.overrides && wall.overrides[index]); });
    if (wall.scene && sceneByHandle(wall.scene)) state.scene = wall.scene;
    var sceneRecord = sceneByHandle(state.scene) || scenes[0];
    if (wall.config && sceneRecord.configs.indexOf(wall.config) !== -1) state.config = wall.config;
    var global = finishShape(wall.global);
    if (global) state.global = global;
    state.gap = gapSize(wall.gap);
    state.focus = null;
    state.panel = null;
    state.wallId = wall.id;
    var name = root.querySelector("[data-p2-walls-name]");
    if (name) name.value = wall.name || "";
    writeWallDetails(wall);
    render();
    markWallSaved();
    paintOwnerWalls();
    return true;
  }

  function saveAsName(name) {
    var current = openedWall();
    if (!current || name !== current.name) return name;
    var copy = "Copy of " + current.name;
    return copy.length > 80 ? copy.slice(0, 80) : copy;
  }

  function readWallDetails() {
    var projectInput = root.querySelector("[data-p2-walls-project]");
    var tagsInput = root.querySelector("[data-p2-walls-tags]");
    var approvalInput = root.querySelector("[data-p2-walls-approval]");
    var project = projectInput ? String(projectInput.value || "").trim().replace(/\s+/g, " ").slice(0, 80) : "";
    var seen = {};
    var tags = (tagsInput ? String(tagsInput.value || "").split(",") : []).map(function (tag) {
      return tag.trim().replace(/\s+/g, " ").slice(0, 24);
    }).filter(function (tag) {
      var key = tag.toLowerCase();
      if (!tag || seen[key]) return false;
      seen[key] = true;
      return true;
    }).slice(0, 8);
    var approval = approvalInput ? approvalInput.value : "";
    if (approval !== "pending" && approval !== "approved" && approval !== "rejected") approval = "";
    return { project: project, tags: tags, approval: approval };
  }

  function writeWallDetails(wall) {
    var projectInput = root.querySelector("[data-p2-walls-project]");
    var tagsInput = root.querySelector("[data-p2-walls-tags]");
    var approvalInput = root.querySelector("[data-p2-walls-approval]");
    if (projectInput) projectInput.value = wall && wall.project || "";
    if (tagsInput) tagsInput.value = wall && Array.isArray(wall.tags) ? wall.tags.join(", ") : "";
    if (approvalInput) approvalInput.value = wall && wall.approval || "";
    var more = root.querySelector("[data-p2-walls-more]");
    if (more) more.open = !!((projectInput && projectInput.value) || (tagsInput && tagsInput.value));
  }

  function paintWallFilter() {
    var filter = root.querySelector("[data-p2-walls-filter]");
    var wrap = root.querySelector("[data-p2-walls-find-wrap]");
    var show = ownerWalls.length > 10;
    if (filter) filter.hidden = !show;
    if (show) return;
    if (wrap) wrap.hidden = true;
    if (filter) filter.setAttribute("aria-expanded", "false");
  }

  function toggleWallFilter() {
    var filter = root.querySelector("[data-p2-walls-filter]");
    var wrap = root.querySelector("[data-p2-walls-find-wrap]");
    var find = root.querySelector("[data-p2-walls-find]");
    if (!wrap || !filter || filter.hidden) return;
    var open = wrap.hidden;
    wrap.hidden = !open;
    filter.setAttribute("aria-expanded", open ? "true" : "false");
    if (open) {
      if (find) find.focus();
      return;
    }
    if (!wallQuery) return;
    wallQuery = "";
    if (find) find.value = "";
    paintOwnerWalls();
  }

  function saveOwnerWall(asNew) {
    var nameInput = root.querySelector("[data-p2-walls-name]");
    var name = wallNameValue();
    if (asNew) name = saveAsName(name);
    var doc = wallDocument();
    if (!doc.items.length) {
      wallStatus("Add a print before saving.");
      return;
    }
    wallStatus(asNew ? "Saving as a new wall…" : "Saving…");
    var details = readWallDetails();
    var payload = {
      op: "save",
      name: name,
      scene: doc.scene,
      config: doc.config,
      gap: doc.gap,
      global: doc.global,
      items: doc.items,
      overrides: doc.overrides,
      project: details.project,
      tags: details.tags,
      approval: details.approval
    };
    if (state.wallId && !asNew) payload.id = state.wallId;
    wallsFetch("", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    }).then(function (res) {
      var wall = res.body && res.body.wall;
      if (!res.ok || !wall) {
        wallStatus(wallError(res.body));
        return;
      }
      state.wallId = wall.id;
      if (nameInput) nameInput.value = wall.name;
      writeWallDetails(wall);
      rememberOwnerWall(wall);
      markWallSaved();
      wallStatus("Saved.");
    }).catch(function () {
      wallStatus("The wall could not be saved. Try again.");
    });
  }

  function openOwnerWall(id) {
    if (!id) return;
    wallStatus("Opening…");
    wallsFetch("?id=" + encodeURIComponent(id)).then(function (res) {
      var wall = res.body && res.body.wall;
      if (!res.ok || !wall || !applyOwnerWall(wall)) {
        wallStatus(wallError(res.body));
        return;
      }
      wallStatus("");
    }).catch(function () {
      wallStatus("That wall could not be opened.");
    });
  }

  function beginRenameWall(id) {
    var wall = ownerWalls.filter(function (row) { return row.id === id; })[0];
    var button = root.querySelector('[data-p2-walls-rename="' + id + '"]');
    var li = button && button.closest("li");
    if (!wall || !li) return;
    li.innerHTML = "";
    var input = document.createElement("input");
    input.type = "text";
    input.maxLength = 80;
    input.value = wall.name;
    input.setAttribute("data-p2-walls-rename-input", id);
    var save = document.createElement("button");
    save.type = "button";
    save.textContent = "Save name";
    save.setAttribute("data-p2-walls-rename-save", id);
    input.addEventListener("keydown", function (event) {
      if (event.key !== "Enter") return;
      event.preventDefault();
      renameOwnerWall(id, input.value);
    });
    li.appendChild(input);
    li.appendChild(save);
    input.focus();
  }

  function renameOwnerWall(id, name) {
    name = String(name || "").trim();
    if (!name) {
      paintOwnerWalls();
      return;
    }
    wallsFetch("", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ op: "rename", id: id, name: name })
    }).then(function (res) {
      var wall = res.body && res.body.wall;
      if (!res.ok || !wall) {
        wallStatus(wallError(res.body));
        paintOwnerWalls();
        return;
      }
      ownerWalls.forEach(function (row) {
        if (row.id === wall.id) row.name = wall.name;
      });
      if (state.wallId === wall.id) {
        var nameInput = root.querySelector("[data-p2-walls-name]");
        if (nameInput) nameInput.value = wall.name;
        markWallSaved();
      }
      paintOwnerWalls();
      wallStatus("Renamed.");
    }).catch(function () {
      wallStatus("The wall could not be renamed.");
    });
  }

  function duplicateOwnerWall(id) {
    wallStatus("Duplicating…");
    wallsFetch("", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ op: "duplicate", id: id })
    }).then(function (res) {
      var wall = res.body && res.body.wall;
      if (!res.ok || !wall) {
        wallStatus(wallError(res.body));
        return;
      }
      rememberOwnerWall(wall);
      wallStatus("Duplicated.");
    }).catch(function () {
      wallStatus("The wall could not be duplicated.");
    });
  }

  function restoreOwnerWall(id) {
    wallStatus("Restoring…");
    wallsFetch("", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ op: "restore", id: id })
    }).then(function (res) {
      var wall = res.body && res.body.wall;
      if (!res.ok || !wall) {
        wallStatus(wallError(res.body));
        return;
      }
      ownerDeleted = ownerDeleted.filter(function (row) { return row.id !== wall.id; });
      rememberOwnerWall(wall);
      wallStatus("Restored " + wall.name + ".");
    }).catch(function () {
      wallStatus("The wall could not be restored.");
    });
  }

  function deleteOwnerWall(id) {
    var wall = ownerWalls.filter(function (row) { return row.id === id; })[0];
    if (!window.confirm("Delete this saved wall? You can restore it from Deleted.")) return;
    wallsFetch("", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ op: "delete", id: id })
    }).then(function (res) {
      if (!res.ok) {
        wallStatus(wallError(res.body));
        return;
      }
      ownerWalls = ownerWalls.filter(function (row) { return row.id !== id; });
      if (wall) ownerDeleted.unshift(wall);
      if (state.wallId === id) {
        state.wallId = null;
        savedStamp = "";
      }
      paintOwnerWalls();
      wallStatus("Deleted. Restore it from Deleted.");
    }).catch(function () {
      wallStatus("The wall could not be deleted.");
    });
  }
})();
